var Sr = Object.defineProperty;
var Ar = (Jt, qt, Wt) => qt in Jt ? Sr(Jt, qt, { enumerable: !0, configurable: !0, writable: !0, value: Wt }) : Jt[qt] = Wt;
var Fe = (Jt, qt, Wt) => (Ar(Jt, typeof qt != "symbol" ? qt + "" : qt, Wt), Wt);
import { c as Er } from "./@contentful-cca97bae.js";
var Ye = { exports: {} };
(function(Jt, qt) {
  (function(Wt, ge) {
    Jt.exports = ge();
  })(self, function() {
    return function() {
      var Wt = { 737: function(C, q, w) {
        var d = w(750), A = w(573), E = A(d("String.prototype.indexOf"));
        C.exports = function(T, I) {
          var y = d(T, !!I);
          return typeof y == "function" && E(T, ".prototype.") > -1 ? A(y) : y;
        };
      }, 573: function(C, q, w) {
        var d = w(132), A = w(750), E = w(504), T = A("%TypeError%"), I = A("%Function.prototype.apply%"), y = A("%Function.prototype.call%"), O = A("%Reflect.apply%", !0) || d.call(y, I), h = A("%Object.defineProperty%", !0), j = A("%Math.max%");
        if (h)
          try {
            h({}, "a", { value: 1 });
          } catch {
            h = null;
          }
        C.exports = function(m) {
          if (typeof m != "function")
            throw new T("a function is required");
          var N = O(d, y, arguments);
          return E(N, 1 + j(0, m.length - (arguments.length - 1)), !0);
        };
        var U = function() {
          return O(d, I, arguments);
        };
        h ? h(C.exports, "apply", { value: U }) : C.exports.apply = U;
      }, 137: function(C) {
        var q = String.prototype.replace, w = /%20/g, d = "RFC3986";
        C.exports = { default: d, formatters: { RFC1738: function(A) {
          return q.call(A, w, "+");
        }, RFC3986: function(A) {
          return String(A);
        } }, RFC1738: "RFC1738", RFC3986: d };
      }, 122: function(C, q, w) {
        var d = w(892), A = w(15), E = w(137);
        C.exports = { formats: E, parse: A, stringify: d };
      }, 15: function(C, q, w) {
        var d = w(634), A = Object.prototype.hasOwnProperty, E = Array.isArray, T = { allowDots: !1, allowPrototypes: !1, allowSparse: !1, arrayLimit: 20, charset: "utf-8", charsetSentinel: !1, comma: !1, decoder: d.decode, delimiter: "&", depth: 5, ignoreQueryPrefix: !1, interpretNumericEntities: !1, parameterLimit: 1e3, parseArrays: !0, plainObjects: !1, strictNullHandling: !1 }, I = function(h) {
          return h.replace(/&#(\d+);/g, function(j, U) {
            return String.fromCharCode(parseInt(U, 10));
          });
        }, y = function(h, j) {
          return h && typeof h == "string" && j.comma && h.indexOf(",") > -1 ? h.split(",") : h;
        }, O = function(h, j, U, m) {
          if (h) {
            var N = U.allowDots ? h.replace(/\.([^.[]+)/g, "[$1]") : h, J = /(\[[^[\]]*])/g, S = U.depth > 0 && /(\[[^[\]]*])/.exec(N), z = S ? N.slice(0, S.index) : N, $ = [];
            if (z) {
              if (!U.plainObjects && A.call(Object.prototype, z) && !U.allowPrototypes)
                return;
              $.push(z);
            }
            for (var R = 0; U.depth > 0 && (S = J.exec(N)) !== null && R < U.depth; ) {
              if (R += 1, !U.plainObjects && A.call(Object.prototype, S[1].slice(1, -1)) && !U.allowPrototypes)
                return;
              $.push(S[1]);
            }
            return S && $.push("[" + N.slice(S.index) + "]"), function(P, Q, Z, M) {
              for (var W = M ? Q : y(Q, Z), G = P.length - 1; G >= 0; --G) {
                var D, X = P[G];
                if (X === "[]" && Z.parseArrays)
                  D = [].concat(W);
                else {
                  D = Z.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
                  var Y = X.charAt(0) === "[" && X.charAt(X.length - 1) === "]" ? X.slice(1, -1) : X, x = parseInt(Y, 10);
                  Z.parseArrays || Y !== "" ? !isNaN(x) && X !== Y && String(x) === Y && x >= 0 && Z.parseArrays && x <= Z.arrayLimit ? (D = [])[x] = W : Y !== "__proto__" && (D[Y] = W) : D = { 0: W };
                }
                W = D;
              }
              return W;
            }($, j, U, m);
          }
        };
        C.exports = function(h, j) {
          var U = function(R) {
            if (!R)
              return T;
            if (R.decoder !== null && R.decoder !== void 0 && typeof R.decoder != "function")
              throw new TypeError("Decoder has to be a function.");
            if (R.charset !== void 0 && R.charset !== "utf-8" && R.charset !== "iso-8859-1")
              throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
            var P = R.charset === void 0 ? T.charset : R.charset;
            return { allowDots: R.allowDots === void 0 ? T.allowDots : !!R.allowDots, allowPrototypes: typeof R.allowPrototypes == "boolean" ? R.allowPrototypes : T.allowPrototypes, allowSparse: typeof R.allowSparse == "boolean" ? R.allowSparse : T.allowSparse, arrayLimit: typeof R.arrayLimit == "number" ? R.arrayLimit : T.arrayLimit, charset: P, charsetSentinel: typeof R.charsetSentinel == "boolean" ? R.charsetSentinel : T.charsetSentinel, comma: typeof R.comma == "boolean" ? R.comma : T.comma, decoder: typeof R.decoder == "function" ? R.decoder : T.decoder, delimiter: typeof R.delimiter == "string" || d.isRegExp(R.delimiter) ? R.delimiter : T.delimiter, depth: typeof R.depth == "number" || R.depth === !1 ? +R.depth : T.depth, ignoreQueryPrefix: R.ignoreQueryPrefix === !0, interpretNumericEntities: typeof R.interpretNumericEntities == "boolean" ? R.interpretNumericEntities : T.interpretNumericEntities, parameterLimit: typeof R.parameterLimit == "number" ? R.parameterLimit : T.parameterLimit, parseArrays: R.parseArrays !== !1, plainObjects: typeof R.plainObjects == "boolean" ? R.plainObjects : T.plainObjects, strictNullHandling: typeof R.strictNullHandling == "boolean" ? R.strictNullHandling : T.strictNullHandling };
          }(j);
          if (h === "" || h == null)
            return U.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
          for (var m = typeof h == "string" ? function(R, P) {
            var Q, Z = { __proto__: null }, M = P.ignoreQueryPrefix ? R.replace(/^\?/, "") : R, W = P.parameterLimit === 1 / 0 ? void 0 : P.parameterLimit, G = M.split(P.delimiter, W), D = -1, X = P.charset;
            if (P.charsetSentinel)
              for (Q = 0; Q < G.length; ++Q)
                G[Q].indexOf("utf8=") === 0 && (G[Q] === "utf8=%E2%9C%93" ? X = "utf-8" : G[Q] === "utf8=%26%2310003%3B" && (X = "iso-8859-1"), D = Q, Q = G.length);
            for (Q = 0; Q < G.length; ++Q)
              if (Q !== D) {
                var Y, x, g = G[Q], L = g.indexOf("]="), H = L === -1 ? g.indexOf("=") : L + 1;
                H === -1 ? (Y = P.decoder(g, T.decoder, X, "key"), x = P.strictNullHandling ? null : "") : (Y = P.decoder(g.slice(0, H), T.decoder, X, "key"), x = d.maybeMap(y(g.slice(H + 1), P), function(rt) {
                  return P.decoder(rt, T.decoder, X, "value");
                })), x && P.interpretNumericEntities && X === "iso-8859-1" && (x = I(x)), g.indexOf("[]=") > -1 && (x = E(x) ? [x] : x), A.call(Z, Y) ? Z[Y] = d.combine(Z[Y], x) : Z[Y] = x;
              }
            return Z;
          }(h, U) : h, N = U.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, J = Object.keys(m), S = 0; S < J.length; ++S) {
            var z = J[S], $ = O(z, m[z], U, typeof h == "string");
            N = d.merge(N, $, U);
          }
          return U.allowSparse === !0 ? N : d.compact(N);
        };
      }, 892: function(C, q, w) {
        var d = w(337), A = w(634), E = w(137), T = Object.prototype.hasOwnProperty, I = { brackets: function(S) {
          return S + "[]";
        }, comma: "comma", indices: function(S, z) {
          return S + "[" + z + "]";
        }, repeat: function(S) {
          return S;
        } }, y = Array.isArray, O = Array.prototype.push, h = function(S, z) {
          O.apply(S, y(z) ? z : [z]);
        }, j = Date.prototype.toISOString, U = E.default, m = { addQueryPrefix: !1, allowDots: !1, charset: "utf-8", charsetSentinel: !1, delimiter: "&", encode: !0, encoder: A.encode, encodeValuesOnly: !1, format: U, formatter: E.formatters[U], indices: !1, serializeDate: function(S) {
          return j.call(S);
        }, skipNulls: !1, strictNullHandling: !1 }, N = {}, J = function S(z, $, R, P, Q, Z, M, W, G, D, X, Y, x, g, L, H) {
          for (var rt, c = z, ot = H, st = 0, At = !1; (ot = ot.get(N)) !== void 0 && !At; ) {
            var tt = ot.get(z);
            if (st += 1, tt !== void 0) {
              if (tt === st)
                throw new RangeError("Cyclic object value");
              At = !0;
            }
            ot.get(N) === void 0 && (st = 0);
          }
          if (typeof W == "function" ? c = W($, c) : c instanceof Date ? c = X(c) : R === "comma" && y(c) && (c = A.maybeMap(c, function(Lt) {
            return Lt instanceof Date ? X(Lt) : Lt;
          })), c === null) {
            if (Q)
              return M && !g ? M($, m.encoder, L, "key", Y) : $;
            c = "";
          }
          if (typeof (rt = c) == "string" || typeof rt == "number" || typeof rt == "boolean" || typeof rt == "symbol" || typeof rt == "bigint" || A.isBuffer(c))
            return M ? [x(g ? $ : M($, m.encoder, L, "key", Y)) + "=" + x(M(c, m.encoder, L, "value", Y))] : [x($) + "=" + x(String(c))];
          var ht, wt = [];
          if (c === void 0)
            return wt;
          if (R === "comma" && y(c))
            g && M && (c = A.maybeMap(c, M)), ht = [{ value: c.length > 0 ? c.join(",") || null : void 0 }];
          else if (y(W))
            ht = W;
          else {
            var mt = Object.keys(c);
            ht = G ? mt.sort(G) : mt;
          }
          for (var Et = P && y(c) && c.length === 1 ? $ + "[]" : $, Ot = 0; Ot < ht.length; ++Ot) {
            var ct = ht[Ot], gt = typeof ct == "object" && ct.value !== void 0 ? ct.value : c[ct];
            if (!Z || gt !== null) {
              var _t = y(c) ? typeof R == "function" ? R(Et, ct) : Et : Et + (D ? "." + ct : "[" + ct + "]");
              H.set(z, st);
              var Tt = d();
              Tt.set(N, H), h(wt, S(gt, _t, R, P, Q, Z, R === "comma" && g && y(c) ? null : M, W, G, D, X, Y, x, g, L, Tt));
            }
          }
          return wt;
        };
        C.exports = function(S, z) {
          var $, R = S, P = function(g) {
            if (!g)
              return m;
            if (g.encoder !== null && g.encoder !== void 0 && typeof g.encoder != "function")
              throw new TypeError("Encoder has to be a function.");
            var L = g.charset || m.charset;
            if (g.charset !== void 0 && g.charset !== "utf-8" && g.charset !== "iso-8859-1")
              throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
            var H = E.default;
            if (g.format !== void 0) {
              if (!T.call(E.formatters, g.format))
                throw new TypeError("Unknown format option provided.");
              H = g.format;
            }
            var rt = E.formatters[H], c = m.filter;
            return (typeof g.filter == "function" || y(g.filter)) && (c = g.filter), { addQueryPrefix: typeof g.addQueryPrefix == "boolean" ? g.addQueryPrefix : m.addQueryPrefix, allowDots: g.allowDots === void 0 ? m.allowDots : !!g.allowDots, charset: L, charsetSentinel: typeof g.charsetSentinel == "boolean" ? g.charsetSentinel : m.charsetSentinel, delimiter: g.delimiter === void 0 ? m.delimiter : g.delimiter, encode: typeof g.encode == "boolean" ? g.encode : m.encode, encoder: typeof g.encoder == "function" ? g.encoder : m.encoder, encodeValuesOnly: typeof g.encodeValuesOnly == "boolean" ? g.encodeValuesOnly : m.encodeValuesOnly, filter: c, format: H, formatter: rt, serializeDate: typeof g.serializeDate == "function" ? g.serializeDate : m.serializeDate, skipNulls: typeof g.skipNulls == "boolean" ? g.skipNulls : m.skipNulls, sort: typeof g.sort == "function" ? g.sort : null, strictNullHandling: typeof g.strictNullHandling == "boolean" ? g.strictNullHandling : m.strictNullHandling };
          }(z);
          typeof P.filter == "function" ? R = (0, P.filter)("", R) : y(P.filter) && ($ = P.filter);
          var Q, Z = [];
          if (typeof R != "object" || R === null)
            return "";
          Q = z && z.arrayFormat in I ? z.arrayFormat : z && "indices" in z ? z.indices ? "indices" : "repeat" : "indices";
          var M = I[Q];
          if (z && "commaRoundTrip" in z && typeof z.commaRoundTrip != "boolean")
            throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
          var W = M === "comma" && z && z.commaRoundTrip;
          $ || ($ = Object.keys(R)), P.sort && $.sort(P.sort);
          for (var G = d(), D = 0; D < $.length; ++D) {
            var X = $[D];
            P.skipNulls && R[X] === null || h(Z, J(R[X], X, M, W, P.strictNullHandling, P.skipNulls, P.encode ? P.encoder : null, P.filter, P.sort, P.allowDots, P.serializeDate, P.format, P.formatter, P.encodeValuesOnly, P.charset, G));
          }
          var Y = Z.join(P.delimiter), x = P.addQueryPrefix === !0 ? "?" : "";
          return P.charsetSentinel && (P.charset === "iso-8859-1" ? x += "utf8=%26%2310003%3B&" : x += "utf8=%E2%9C%93&"), Y.length > 0 ? x + Y : "";
        };
      }, 634: function(C, q, w) {
        var d = w(137), A = Object.prototype.hasOwnProperty, E = Array.isArray, T = function() {
          for (var y = [], O = 0; O < 256; ++O)
            y.push("%" + ((O < 16 ? "0" : "") + O.toString(16)).toUpperCase());
          return y;
        }(), I = function(y, O) {
          for (var h = O && O.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, j = 0; j < y.length; ++j)
            y[j] !== void 0 && (h[j] = y[j]);
          return h;
        };
        C.exports = { arrayToObject: I, assign: function(y, O) {
          return Object.keys(O).reduce(function(h, j) {
            return h[j] = O[j], h;
          }, y);
        }, combine: function(y, O) {
          return [].concat(y, O);
        }, compact: function(y) {
          for (var O = [{ obj: { o: y }, prop: "o" }], h = [], j = 0; j < O.length; ++j)
            for (var U = O[j], m = U.obj[U.prop], N = Object.keys(m), J = 0; J < N.length; ++J) {
              var S = N[J], z = m[S];
              typeof z == "object" && z !== null && h.indexOf(z) === -1 && (O.push({ obj: m, prop: S }), h.push(z));
            }
          return function($) {
            for (; $.length > 1; ) {
              var R = $.pop(), P = R.obj[R.prop];
              if (E(P)) {
                for (var Q = [], Z = 0; Z < P.length; ++Z)
                  P[Z] !== void 0 && Q.push(P[Z]);
                R.obj[R.prop] = Q;
              }
            }
          }(O), y;
        }, decode: function(y, O, h) {
          var j = y.replace(/\+/g, " ");
          if (h === "iso-8859-1")
            return j.replace(/%[0-9a-f]{2}/gi, unescape);
          try {
            return decodeURIComponent(j);
          } catch {
            return j;
          }
        }, encode: function(y, O, h, j, U) {
          if (y.length === 0)
            return y;
          var m = y;
          if (typeof y == "symbol" ? m = Symbol.prototype.toString.call(y) : typeof y != "string" && (m = String(y)), h === "iso-8859-1")
            return escape(m).replace(/%u[0-9a-f]{4}/gi, function(z) {
              return "%26%23" + parseInt(z.slice(2), 16) + "%3B";
            });
          for (var N = "", J = 0; J < m.length; ++J) {
            var S = m.charCodeAt(J);
            S === 45 || S === 46 || S === 95 || S === 126 || S >= 48 && S <= 57 || S >= 65 && S <= 90 || S >= 97 && S <= 122 || U === d.RFC1738 && (S === 40 || S === 41) ? N += m.charAt(J) : S < 128 ? N += T[S] : S < 2048 ? N += T[192 | S >> 6] + T[128 | 63 & S] : S < 55296 || S >= 57344 ? N += T[224 | S >> 12] + T[128 | S >> 6 & 63] + T[128 | 63 & S] : (J += 1, S = 65536 + ((1023 & S) << 10 | 1023 & m.charCodeAt(J)), N += T[240 | S >> 18] + T[128 | S >> 12 & 63] + T[128 | S >> 6 & 63] + T[128 | 63 & S]);
          }
          return N;
        }, isBuffer: function(y) {
          return !(!y || typeof y != "object" || !(y.constructor && y.constructor.isBuffer && y.constructor.isBuffer(y)));
        }, isRegExp: function(y) {
          return Object.prototype.toString.call(y) === "[object RegExp]";
        }, maybeMap: function(y, O) {
          if (E(y)) {
            for (var h = [], j = 0; j < y.length; j += 1)
              h.push(O(y[j]));
            return h;
          }
          return O(y);
        }, merge: function y(O, h, j) {
          if (!h)
            return O;
          if (typeof h != "object") {
            if (E(O))
              O.push(h);
            else {
              if (!O || typeof O != "object")
                return [O, h];
              (j && (j.plainObjects || j.allowPrototypes) || !A.call(Object.prototype, h)) && (O[h] = !0);
            }
            return O;
          }
          if (!O || typeof O != "object")
            return [O].concat(h);
          var U = O;
          return E(O) && !E(h) && (U = I(O, j)), E(O) && E(h) ? (h.forEach(function(m, N) {
            if (A.call(O, N)) {
              var J = O[N];
              J && typeof J == "object" && m && typeof m == "object" ? O[N] = y(J, m, j) : O.push(m);
            } else
              O[N] = m;
          }), O) : Object.keys(h).reduce(function(m, N) {
            var J = h[N];
            return A.call(m, N) ? m[N] = y(m[N], J, j) : m[N] = J, m;
          }, U);
        } };
      }, 300: function(C, q, w) {
        var d = w(365)(), A = w(750), E = d && A("%Object.defineProperty%", !0);
        if (E)
          try {
            E({}, "a", { value: 1 });
          } catch {
            E = !1;
          }
        var T = A("%SyntaxError%"), I = A("%TypeError%"), y = w(502);
        C.exports = function(O, h, j) {
          if (!O || typeof O != "object" && typeof O != "function")
            throw new I("`obj` must be an object or a function`");
          if (typeof h != "string" && typeof h != "symbol")
            throw new I("`property` must be a string or a symbol`");
          if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
            throw new I("`nonEnumerable`, if provided, must be a boolean or null");
          if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
            throw new I("`nonWritable`, if provided, must be a boolean or null");
          if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
            throw new I("`nonConfigurable`, if provided, must be a boolean or null");
          if (arguments.length > 6 && typeof arguments[6] != "boolean")
            throw new I("`loose`, if provided, must be a boolean");
          var U = arguments.length > 3 ? arguments[3] : null, m = arguments.length > 4 ? arguments[4] : null, N = arguments.length > 5 ? arguments[5] : null, J = arguments.length > 6 && arguments[6], S = !!y && y(O, h);
          if (E)
            E(O, h, { configurable: N === null && S ? S.configurable : !N, enumerable: U === null && S ? S.enumerable : !U, value: j, writable: m === null && S ? S.writable : !m });
          else {
            if (!J && (U || m || N))
              throw new T("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
            O[h] = j;
          }
        };
      }, 581: function(C, q, w) {
        C.exports = function() {
          var d = Function.prototype.toString, A = Object.create, E = Object.defineProperty, T = Object.getOwnPropertyDescriptor, I = Object.getOwnPropertyNames, y = Object.getOwnPropertySymbols, O = Object.getPrototypeOf, h = Object.prototype, j = h.hasOwnProperty, U = h.propertyIsEnumerable, m = typeof y == "function", N = typeof WeakMap == "function", J = function() {
            if (N)
              return function() {
                return /* @__PURE__ */ new WeakMap();
              };
            var M = function() {
              function W() {
                this._keys = [], this._values = [];
              }
              return W.prototype.has = function(G) {
                return !!~this._keys.indexOf(G);
              }, W.prototype.get = function(G) {
                return this._values[this._keys.indexOf(G)];
              }, W.prototype.set = function(G, D) {
                this._keys.push(G), this._values.push(D);
              }, W;
            }();
            return function() {
              return new M();
            };
          }(), S = function(M, W) {
            var G = M.__proto__ || O(M);
            if (!G)
              return A(null);
            var D = G.constructor;
            if (D === W.Object)
              return G === W.Object.prototype ? {} : A(G);
            if (~d.call(D).indexOf("[native code]"))
              try {
                return new D();
              } catch {
              }
            return A(G);
          }, z = function(M, W, G, D) {
            var X = S(M, W);
            for (var Y in D.set(M, X), M)
              j.call(M, Y) && (X[Y] = G(M[Y], D));
            if (m)
              for (var x = y(M), g = 0, L = x.length, H = void 0; g < L; ++g)
                H = x[g], U.call(M, H) && (X[H] = G(M[H], D));
            return X;
          }, $ = function(M, W, G, D) {
            var X = S(M, W);
            D.set(M, X);
            for (var Y = m ? I(M).concat(y(M)) : I(M), x = 0, g = Y.length, L = void 0, H = void 0; x < g; ++x)
              if ((L = Y[x]) !== "callee" && L !== "caller")
                if (H = T(M, L)) {
                  H.get || H.set || (H.value = G(M[L], D));
                  try {
                    E(X, L, H);
                  } catch {
                    X[L] = H.value;
                  }
                } else
                  X[L] = G(M[L], D);
            return X;
          }, R = Array.isArray, P = Object.getPrototypeOf, Q = function() {
            return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : w.g !== void 0 ? w.g : (console && console.error && console.error('Unable to locate global object, returning "this".'), this);
          }();
          function Z(M, W) {
            var G = !(!W || !W.isStrict), D = W && W.realm || Q, X = G ? $ : z, Y = function(x, g) {
              if (!x || typeof x != "object")
                return x;
              if (g.has(x))
                return g.get(x);
              var L, H, rt, c = x.__proto__ || P(x), ot = c && c.constructor;
              if (!ot || ot === D.Object)
                return X(x, D, Y, g);
              if (R(x)) {
                if (G)
                  return $(x, D, Y, g);
                L = new ot(), g.set(x, L);
                for (var st = 0, At = x.length; st < At; ++st)
                  L[st] = Y(x[st], g);
                return L;
              }
              if (x instanceof D.Date)
                return new ot(x.getTime());
              if (x instanceof D.RegExp)
                return (L = new ot(x.source, x.flags || (H = x, rt = "", H.global && (rt += "g"), H.ignoreCase && (rt += "i"), H.multiline && (rt += "m"), H.unicode && (rt += "u"), H.sticky && (rt += "y"), rt))).lastIndex = x.lastIndex, L;
              if (D.Map && x instanceof D.Map)
                return L = new ot(), g.set(x, L), x.forEach(function(tt, ht) {
                  L.set(ht, Y(tt, g));
                }), L;
              if (D.Set && x instanceof D.Set)
                return L = new ot(), g.set(x, L), x.forEach(function(tt) {
                  L.add(Y(tt, g));
                }), L;
              if (D.Blob && x instanceof D.Blob)
                return x.slice(0, x.size, x.type);
              if (D.Buffer && D.Buffer.isBuffer(x))
                return L = D.Buffer.allocUnsafe ? D.Buffer.allocUnsafe(x.length) : new ot(x.length), g.set(x, L), x.copy(L), L;
              if (D.ArrayBuffer) {
                if (D.ArrayBuffer.isView(x))
                  return L = new ot(x.buffer.slice(0)), g.set(x, L), L;
                if (x instanceof D.ArrayBuffer)
                  return L = x.slice(0), g.set(x, L), L;
              }
              return typeof x.then == "function" || x instanceof Error || D.WeakMap && x instanceof D.WeakMap || D.WeakSet && x instanceof D.WeakSet ? x : X(x, D, Y, g);
            };
            return Y(M, J());
          }
          return Z.default = Z, Z.strict = function(M, W) {
            return Z(M, { isStrict: !0, realm: W ? W.realm : void 0 });
          }, Z;
        }();
      }, 458: function(C) {
        var q = Object.prototype.toString, w = Math.max, d = function(A, E) {
          for (var T = [], I = 0; I < A.length; I += 1)
            T[I] = A[I];
          for (var y = 0; y < E.length; y += 1)
            T[y + A.length] = E[y];
          return T;
        };
        C.exports = function(A) {
          var E = this;
          if (typeof E != "function" || q.apply(E) !== "[object Function]")
            throw new TypeError("Function.prototype.bind called on incompatible " + E);
          for (var T, I = function(U, m) {
            for (var N = [], J = 1, S = 0; J < U.length; J += 1, S += 1)
              N[S] = U[J];
            return N;
          }(arguments), y = w(0, E.length - I.length), O = [], h = 0; h < y; h++)
            O[h] = "$" + h;
          if (T = Function("binder", "return function (" + function(U, m) {
            for (var N = "", J = 0; J < U.length; J += 1)
              N += U[J], J + 1 < U.length && (N += ",");
            return N;
          }(O) + "){ return binder.apply(this,arguments); }")(function() {
            if (this instanceof T) {
              var U = E.apply(this, d(I, arguments));
              return Object(U) === U ? U : this;
            }
            return E.apply(A, d(I, arguments));
          }), E.prototype) {
            var j = function() {
            };
            j.prototype = E.prototype, T.prototype = new j(), j.prototype = null;
          }
          return T;
        };
      }, 132: function(C, q, w) {
        var d = w(458);
        C.exports = Function.prototype.bind || d;
      }, 750: function(C, q, w) {
        var d, A = SyntaxError, E = Function, T = TypeError, I = function(g) {
          try {
            return E('"use strict"; return (' + g + ").constructor;")();
          } catch {
          }
        }, y = Object.getOwnPropertyDescriptor;
        if (y)
          try {
            y({}, "");
          } catch {
            y = null;
          }
        var O = function() {
          throw new T();
        }, h = y ? function() {
          try {
            return O;
          } catch {
            try {
              return y(arguments, "callee").get;
            } catch {
              return O;
            }
          }
        }() : O, j = w(679)(), U = w(574)(), m = Object.getPrototypeOf || (U ? function(g) {
          return g.__proto__;
        } : null), N = {}, J = typeof Uint8Array < "u" && m ? m(Uint8Array) : d, S = { "%AggregateError%": typeof AggregateError > "u" ? d : AggregateError, "%Array%": Array, "%ArrayBuffer%": typeof ArrayBuffer > "u" ? d : ArrayBuffer, "%ArrayIteratorPrototype%": j && m ? m([][Symbol.iterator]()) : d, "%AsyncFromSyncIteratorPrototype%": d, "%AsyncFunction%": N, "%AsyncGenerator%": N, "%AsyncGeneratorFunction%": N, "%AsyncIteratorPrototype%": N, "%Atomics%": typeof Atomics > "u" ? d : Atomics, "%BigInt%": typeof BigInt > "u" ? d : BigInt, "%BigInt64Array%": typeof BigInt64Array > "u" ? d : BigInt64Array, "%BigUint64Array%": typeof BigUint64Array > "u" ? d : BigUint64Array, "%Boolean%": Boolean, "%DataView%": typeof DataView > "u" ? d : DataView, "%Date%": Date, "%decodeURI%": decodeURI, "%decodeURIComponent%": decodeURIComponent, "%encodeURI%": encodeURI, "%encodeURIComponent%": encodeURIComponent, "%Error%": Error, "%eval%": eval, "%EvalError%": EvalError, "%Float32Array%": typeof Float32Array > "u" ? d : Float32Array, "%Float64Array%": typeof Float64Array > "u" ? d : Float64Array, "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? d : FinalizationRegistry, "%Function%": E, "%GeneratorFunction%": N, "%Int8Array%": typeof Int8Array > "u" ? d : Int8Array, "%Int16Array%": typeof Int16Array > "u" ? d : Int16Array, "%Int32Array%": typeof Int32Array > "u" ? d : Int32Array, "%isFinite%": isFinite, "%isNaN%": isNaN, "%IteratorPrototype%": j && m ? m(m([][Symbol.iterator]())) : d, "%JSON%": typeof JSON == "object" ? JSON : d, "%Map%": typeof Map > "u" ? d : Map, "%MapIteratorPrototype%": typeof Map < "u" && j && m ? m((/* @__PURE__ */ new Map())[Symbol.iterator]()) : d, "%Math%": Math, "%Number%": Number, "%Object%": Object, "%parseFloat%": parseFloat, "%parseInt%": parseInt, "%Promise%": typeof Promise > "u" ? d : Promise, "%Proxy%": typeof Proxy > "u" ? d : Proxy, "%RangeError%": RangeError, "%ReferenceError%": ReferenceError, "%Reflect%": typeof Reflect > "u" ? d : Reflect, "%RegExp%": RegExp, "%Set%": typeof Set > "u" ? d : Set, "%SetIteratorPrototype%": typeof Set < "u" && j && m ? m((/* @__PURE__ */ new Set())[Symbol.iterator]()) : d, "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? d : SharedArrayBuffer, "%String%": String, "%StringIteratorPrototype%": j && m ? m(""[Symbol.iterator]()) : d, "%Symbol%": j ? Symbol : d, "%SyntaxError%": A, "%ThrowTypeError%": h, "%TypedArray%": J, "%TypeError%": T, "%Uint8Array%": typeof Uint8Array > "u" ? d : Uint8Array, "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? d : Uint8ClampedArray, "%Uint16Array%": typeof Uint16Array > "u" ? d : Uint16Array, "%Uint32Array%": typeof Uint32Array > "u" ? d : Uint32Array, "%URIError%": URIError, "%WeakMap%": typeof WeakMap > "u" ? d : WeakMap, "%WeakRef%": typeof WeakRef > "u" ? d : WeakRef, "%WeakSet%": typeof WeakSet > "u" ? d : WeakSet };
        if (m)
          try {
            null.error;
          } catch (g) {
            var z = m(m(g));
            S["%Error.prototype%"] = z;
          }
        var $ = function g(L) {
          var H;
          if (L === "%AsyncFunction%")
            H = I("async function () {}");
          else if (L === "%GeneratorFunction%")
            H = I("function* () {}");
          else if (L === "%AsyncGeneratorFunction%")
            H = I("async function* () {}");
          else if (L === "%AsyncGenerator%") {
            var rt = g("%AsyncGeneratorFunction%");
            rt && (H = rt.prototype);
          } else if (L === "%AsyncIteratorPrototype%") {
            var c = g("%AsyncGenerator%");
            c && m && (H = m(c.prototype));
          }
          return S[L] = H, H;
        }, R = { "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"], "%ArrayPrototype%": ["Array", "prototype"], "%ArrayProto_entries%": ["Array", "prototype", "entries"], "%ArrayProto_forEach%": ["Array", "prototype", "forEach"], "%ArrayProto_keys%": ["Array", "prototype", "keys"], "%ArrayProto_values%": ["Array", "prototype", "values"], "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"], "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"], "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"], "%BooleanPrototype%": ["Boolean", "prototype"], "%DataViewPrototype%": ["DataView", "prototype"], "%DatePrototype%": ["Date", "prototype"], "%ErrorPrototype%": ["Error", "prototype"], "%EvalErrorPrototype%": ["EvalError", "prototype"], "%Float32ArrayPrototype%": ["Float32Array", "prototype"], "%Float64ArrayPrototype%": ["Float64Array", "prototype"], "%FunctionPrototype%": ["Function", "prototype"], "%Generator%": ["GeneratorFunction", "prototype"], "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"], "%Int8ArrayPrototype%": ["Int8Array", "prototype"], "%Int16ArrayPrototype%": ["Int16Array", "prototype"], "%Int32ArrayPrototype%": ["Int32Array", "prototype"], "%JSONParse%": ["JSON", "parse"], "%JSONStringify%": ["JSON", "stringify"], "%MapPrototype%": ["Map", "prototype"], "%NumberPrototype%": ["Number", "prototype"], "%ObjectPrototype%": ["Object", "prototype"], "%ObjProto_toString%": ["Object", "prototype", "toString"], "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"], "%PromisePrototype%": ["Promise", "prototype"], "%PromiseProto_then%": ["Promise", "prototype", "then"], "%Promise_all%": ["Promise", "all"], "%Promise_reject%": ["Promise", "reject"], "%Promise_resolve%": ["Promise", "resolve"], "%RangeErrorPrototype%": ["RangeError", "prototype"], "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"], "%RegExpPrototype%": ["RegExp", "prototype"], "%SetPrototype%": ["Set", "prototype"], "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"], "%StringPrototype%": ["String", "prototype"], "%SymbolPrototype%": ["Symbol", "prototype"], "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"], "%TypedArrayPrototype%": ["TypedArray", "prototype"], "%TypeErrorPrototype%": ["TypeError", "prototype"], "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"], "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"], "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"], "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"], "%URIErrorPrototype%": ["URIError", "prototype"], "%WeakMapPrototype%": ["WeakMap", "prototype"], "%WeakSetPrototype%": ["WeakSet", "prototype"] }, P = w(132), Q = w(712), Z = P.call(Function.call, Array.prototype.concat), M = P.call(Function.apply, Array.prototype.splice), W = P.call(Function.call, String.prototype.replace), G = P.call(Function.call, String.prototype.slice), D = P.call(Function.call, RegExp.prototype.exec), X = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, Y = /\\(\\)?/g, x = function(g, L) {
          var H, rt = g;
          if (Q(R, rt) && (rt = "%" + (H = R[rt])[0] + "%"), Q(S, rt)) {
            var c = S[rt];
            if (c === N && (c = $(rt)), c === void 0 && !L)
              throw new T("intrinsic " + g + " exists, but is not available. Please file an issue!");
            return { alias: H, name: rt, value: c };
          }
          throw new A("intrinsic " + g + " does not exist!");
        };
        C.exports = function(g, L) {
          if (typeof g != "string" || g.length === 0)
            throw new T("intrinsic name must be a non-empty string");
          if (arguments.length > 1 && typeof L != "boolean")
            throw new T('"allowMissing" argument must be a boolean');
          if (D(/^%?[^%]*%?$/, g) === null)
            throw new A("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
          var H = function(gt) {
            var _t = G(gt, 0, 1), Tt = G(gt, -1);
            if (_t === "%" && Tt !== "%")
              throw new A("invalid intrinsic syntax, expected closing `%`");
            if (Tt === "%" && _t !== "%")
              throw new A("invalid intrinsic syntax, expected opening `%`");
            var Lt = [];
            return W(gt, X, function(Ct, zt, Vt, bt) {
              Lt[Lt.length] = Vt ? W(bt, Y, "$1") : zt || Ct;
            }), Lt;
          }(g), rt = H.length > 0 ? H[0] : "", c = x("%" + rt + "%", L), ot = c.name, st = c.value, At = !1, tt = c.alias;
          tt && (rt = tt[0], M(H, Z([0, 1], tt)));
          for (var ht = 1, wt = !0; ht < H.length; ht += 1) {
            var mt = H[ht], Et = G(mt, 0, 1), Ot = G(mt, -1);
            if ((Et === '"' || Et === "'" || Et === "`" || Ot === '"' || Ot === "'" || Ot === "`") && Et !== Ot)
              throw new A("property names with quotes must have matching quotes");
            if (mt !== "constructor" && wt || (At = !0), Q(S, ot = "%" + (rt += "." + mt) + "%"))
              st = S[ot];
            else if (st != null) {
              if (!(mt in st)) {
                if (!L)
                  throw new T("base intrinsic for " + g + " exists, but the property is not available.");
                return;
              }
              if (y && ht + 1 >= H.length) {
                var ct = y(st, mt);
                st = (wt = !!ct) && "get" in ct && !("originalValue" in ct.get) ? ct.get : st[mt];
              } else
                wt = Q(st, mt), st = st[mt];
              wt && !At && (S[ot] = st);
            }
          }
          return st;
        };
      }, 502: function(C, q, w) {
        var d = w(750)("%Object.getOwnPropertyDescriptor%", !0);
        if (d)
          try {
            d([], "length");
          } catch {
            d = null;
          }
        C.exports = d;
      }, 365: function(C, q, w) {
        var d = w(750)("%Object.defineProperty%", !0), A = function() {
          if (d)
            try {
              return d({}, "a", { value: 1 }), !0;
            } catch {
              return !1;
            }
          return !1;
        };
        A.hasArrayLengthDefineBug = function() {
          if (!A())
            return null;
          try {
            return d([], "length", { value: 1 }).length !== 1;
          } catch {
            return !0;
          }
        }, C.exports = A;
      }, 574: function(C) {
        var q = { foo: {} }, w = Object;
        C.exports = function() {
          return { __proto__: q }.foo === q.foo && !({ __proto__: null } instanceof w);
        };
      }, 679: function(C, q, w) {
        var d = typeof Symbol < "u" && Symbol, A = w(186);
        C.exports = function() {
          return typeof d == "function" && typeof Symbol == "function" && typeof d("foo") == "symbol" && typeof Symbol("bar") == "symbol" && A();
        };
      }, 186: function(C) {
        C.exports = function() {
          if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
            return !1;
          if (typeof Symbol.iterator == "symbol")
            return !0;
          var q = {}, w = Symbol("test"), d = Object(w);
          if (typeof w == "string" || Object.prototype.toString.call(w) !== "[object Symbol]" || Object.prototype.toString.call(d) !== "[object Symbol]")
            return !1;
          for (w in q[w] = 42, q)
            return !1;
          if (typeof Object.keys == "function" && Object.keys(q).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(q).length !== 0)
            return !1;
          var A = Object.getOwnPropertySymbols(q);
          if (A.length !== 1 || A[0] !== w || !Object.prototype.propertyIsEnumerable.call(q, w))
            return !1;
          if (typeof Object.getOwnPropertyDescriptor == "function") {
            var E = Object.getOwnPropertyDescriptor(q, w);
            if (E.value !== 42 || E.enumerable !== !0)
              return !1;
          }
          return !0;
        };
      }, 712: function(C, q, w) {
        var d = Function.prototype.call, A = Object.prototype.hasOwnProperty, E = w(132);
        C.exports = E.call(d, A);
      }, 784: function(C, q) {
        function w(d, A) {
          var E = [], T = [];
          return A == null && (A = function(I, y) {
            return E[0] === y ? "[Circular ~]" : "[Circular ~." + T.slice(0, E.indexOf(y)).join(".") + "]";
          }), function(I, y) {
            if (E.length > 0) {
              var O = E.indexOf(this);
              ~O ? E.splice(O + 1) : E.push(this), ~O ? T.splice(O, 1 / 0, I) : T.push(I), ~E.indexOf(y) && (y = A.call(this, I, y));
            } else
              E.push(y);
            return d == null ? y : d.call(this, I, y);
          };
        }
        (C.exports = function(d, A, E, T) {
          return JSON.stringify(d, w(A, T), E);
        }).getSerialize = w;
      }, 261: function(C) {
        var q, w, d = Function.prototype, A = Object.prototype, E = d.toString, T = A.hasOwnProperty, I = E.call(Object), y = A.toString, O = (q = Object.getPrototypeOf, w = Object, function(h) {
          return q(w(h));
        });
        C.exports = function(h) {
          if (!function(m) {
            return !!m && typeof m == "object";
          }(h) || y.call(h) != "[object Object]" || function(m) {
            var N = !1;
            if (m != null && typeof m.toString != "function")
              try {
                N = !!(m + "");
              } catch {
              }
            return N;
          }(h))
            return !1;
          var j = O(h);
          if (j === null)
            return !0;
          var U = T.call(j, "constructor") && j.constructor;
          return typeof U == "function" && U instanceof U && E.call(U) == I;
        };
      }, 451: function(C) {
        var q = Object.prototype.toString, w = Array.isArray;
        C.exports = function(d) {
          return typeof d == "string" || !w(d) && function(A) {
            return !!A && typeof A == "object";
          }(d) && q.call(d) == "[object String]";
        };
      }, 524: function(C, q, w) {
        var d = typeof Map == "function" && Map.prototype, A = Object.getOwnPropertyDescriptor && d ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, E = d && A && typeof A.get == "function" ? A.get : null, T = d && Map.prototype.forEach, I = typeof Set == "function" && Set.prototype, y = Object.getOwnPropertyDescriptor && I ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, O = I && y && typeof y.get == "function" ? y.get : null, h = I && Set.prototype.forEach, j = typeof WeakMap == "function" && WeakMap.prototype ? WeakMap.prototype.has : null, U = typeof WeakSet == "function" && WeakSet.prototype ? WeakSet.prototype.has : null, m = typeof WeakRef == "function" && WeakRef.prototype ? WeakRef.prototype.deref : null, N = Boolean.prototype.valueOf, J = Object.prototype.toString, S = Function.prototype.toString, z = String.prototype.match, $ = String.prototype.slice, R = String.prototype.replace, P = String.prototype.toUpperCase, Q = String.prototype.toLowerCase, Z = RegExp.prototype.test, M = Array.prototype.concat, W = Array.prototype.join, G = Array.prototype.slice, D = Math.floor, X = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, Y = Object.getOwnPropertySymbols, x = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, g = typeof Symbol == "function" && typeof Symbol.iterator == "object", L = typeof Symbol == "function" && Symbol.toStringTag ? Symbol.toStringTag : null, H = Object.prototype.propertyIsEnumerable, rt = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(k) {
          return k.__proto__;
        } : null);
        function c(k, p) {
          if (k === 1 / 0 || k === -1 / 0 || k != k || k && k > -1e3 && k < 1e3 || Z.call(/e/, p))
            return p;
          var it = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
          if (typeof k == "number") {
            var nt = k < 0 ? -D(-k) : D(k);
            if (nt !== k) {
              var yt = String(nt), et = $.call(p, yt.length + 1);
              return R.call(yt, it, "$&_") + "." + R.call(R.call(et, /([0-9]{3})/g, "$&_"), /_$/, "");
            }
          }
          return R.call(p, it, "$&_");
        }
        var ot = w(553), st = ot.custom, At = Et(st) ? st : null;
        function tt(k, p, it) {
          var nt = (it.quoteStyle || p) === "double" ? '"' : "'";
          return nt + k + nt;
        }
        function ht(k) {
          return R.call(String(k), /"/g, "&quot;");
        }
        function wt(k) {
          return !(gt(k) !== "[object Array]" || L && typeof k == "object" && L in k);
        }
        function mt(k) {
          return !(gt(k) !== "[object RegExp]" || L && typeof k == "object" && L in k);
        }
        function Et(k) {
          if (g)
            return k && typeof k == "object" && k instanceof Symbol;
          if (typeof k == "symbol")
            return !0;
          if (!k || typeof k != "object" || !x)
            return !1;
          try {
            return x.call(k), !0;
          } catch {
          }
          return !1;
        }
        C.exports = function k(p, it, nt, yt) {
          var et = it || {};
          if (ct(et, "quoteStyle") && et.quoteStyle !== "single" && et.quoteStyle !== "double")
            throw new TypeError('option "quoteStyle" must be "single" or "double"');
          if (ct(et, "maxStringLength") && (typeof et.maxStringLength == "number" ? et.maxStringLength < 0 && et.maxStringLength !== 1 / 0 : et.maxStringLength !== null))
            throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
          var vt = !ct(et, "customInspect") || et.customInspect;
          if (typeof vt != "boolean" && vt !== "symbol")
            throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
          if (ct(et, "indent") && et.indent !== null && et.indent !== "	" && !(parseInt(et.indent, 10) === et.indent && et.indent > 0))
            throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
          if (ct(et, "numericSeparator") && typeof et.numericSeparator != "boolean")
            throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
          var Pt = et.numericSeparator;
          if (p === void 0)
            return "undefined";
          if (p === null)
            return "null";
          if (typeof p == "boolean")
            return p ? "true" : "false";
          if (typeof p == "string")
            return Tt(p, et);
          if (typeof p == "number") {
            if (p === 0)
              return 1 / 0 / p > 0 ? "0" : "-0";
            var ft = String(p);
            return Pt ? c(p, ft) : ft;
          }
          if (typeof p == "bigint") {
            var Rt = String(p) + "n";
            return Pt ? c(p, Rt) : Rt;
          }
          var ee = et.depth === void 0 ? 5 : et.depth;
          if (nt === void 0 && (nt = 0), nt >= ee && ee > 0 && typeof p == "object")
            return wt(p) ? "[Array]" : "[Object]";
          var Ht, Ut = function(_, at) {
            var Bt;
            if (_.indent === "	")
              Bt = "	";
            else {
              if (!(typeof _.indent == "number" && _.indent > 0))
                return null;
              Bt = W.call(Array(_.indent + 1), " ");
            }
            return { base: Bt, prev: W.call(Array(at + 1), Bt) };
          }(et, nt);
          if (yt === void 0)
            yt = [];
          else if (_t(yt, p) >= 0)
            return "[Circular]";
          function jt(_, at, Bt) {
            if (at && (yt = G.call(yt)).push(at), Bt) {
              var ve = { depth: et.depth };
              return ct(et, "quoteStyle") && (ve.quoteStyle = et.quoteStyle), k(_, ve, nt + 1, yt);
            }
            return k(_, et, nt + 1, yt);
          }
          if (typeof p == "function" && !mt(p)) {
            var ue = function(_) {
              if (_.name)
                return _.name;
              var at = z.call(S.call(_), /^function\s*([\w$]+)/);
              return at ? at[1] : null;
            }(p), be = Kt(p, jt);
            return "[Function" + (ue ? ": " + ue : " (anonymous)") + "]" + (be.length > 0 ? " { " + W.call(be, ", ") + " }" : "");
          }
          if (Et(p)) {
            var le = g ? R.call(String(p), /^(Symbol\(.*\))_[^)]*$/, "$1") : x.call(p);
            return typeof p != "object" || g ? le : Ct(le);
          }
          if ((Ht = p) && typeof Ht == "object" && (typeof HTMLElement < "u" && Ht instanceof HTMLElement || typeof Ht.nodeName == "string" && typeof Ht.getAttribute == "function")) {
            for (var $t = "<" + Q.call(String(p.nodeName)), re = p.attributes || [], ne = 0; ne < re.length; ne++)
              $t += " " + re[ne].name + "=" + tt(ht(re[ne].value), "double", et);
            return $t += ">", p.childNodes && p.childNodes.length && ($t += "..."), $t + "</" + Q.call(String(p.nodeName)) + ">";
          }
          if (wt(p)) {
            if (p.length === 0)
              return "[]";
            var oe = Kt(p, jt);
            return Ut && !function(_) {
              for (var at = 0; at < _.length; at++)
                if (_t(_[at], `
`) >= 0)
                  return !1;
              return !0;
            }(oe) ? "[" + bt(oe, Ut) + "]" : "[ " + W.call(oe, ", ") + " ]";
          }
          if (function(_) {
            return !(gt(_) !== "[object Error]" || L && typeof _ == "object" && L in _);
          }(p)) {
            var Qt = Kt(p, jt);
            return "cause" in Error.prototype || !("cause" in p) || H.call(p, "cause") ? Qt.length === 0 ? "[" + String(p) + "]" : "{ [" + String(p) + "] " + W.call(Qt, ", ") + " }" : "{ [" + String(p) + "] " + W.call(M.call("[cause]: " + jt(p.cause), Qt), ", ") + " }";
          }
          if (typeof p == "object" && vt) {
            if (At && typeof p[At] == "function" && ot)
              return ot(p, { depth: ee - nt });
            if (vt !== "symbol" && typeof p.inspect == "function")
              return p.inspect();
          }
          if (function(_) {
            if (!E || !_ || typeof _ != "object")
              return !1;
            try {
              E.call(_);
              try {
                O.call(_);
              } catch {
                return !0;
              }
              return _ instanceof Map;
            } catch {
            }
            return !1;
          }(p)) {
            var fe = [];
            return T && T.call(p, function(_, at) {
              fe.push(jt(at, p, !0) + " => " + jt(_, p));
            }), Vt("Map", E.call(p), fe, Ut);
          }
          if (function(_) {
            if (!O || !_ || typeof _ != "object")
              return !1;
            try {
              O.call(_);
              try {
                E.call(_);
              } catch {
                return !0;
              }
              return _ instanceof Set;
            } catch {
            }
            return !1;
          }(p)) {
            var pe = [];
            return h && h.call(p, function(_) {
              pe.push(jt(_, p));
            }), Vt("Set", O.call(p), pe, Ut);
          }
          if (function(_) {
            if (!j || !_ || typeof _ != "object")
              return !1;
            try {
              j.call(_, j);
              try {
                U.call(_, U);
              } catch {
                return !0;
              }
              return _ instanceof WeakMap;
            } catch {
            }
            return !1;
          }(p))
            return zt("WeakMap");
          if (function(_) {
            if (!U || !_ || typeof _ != "object")
              return !1;
            try {
              U.call(_, U);
              try {
                j.call(_, j);
              } catch {
                return !0;
              }
              return _ instanceof WeakSet;
            } catch {
            }
            return !1;
          }(p))
            return zt("WeakSet");
          if (function(_) {
            if (!m || !_ || typeof _ != "object")
              return !1;
            try {
              return m.call(_), !0;
            } catch {
            }
            return !1;
          }(p))
            return zt("WeakRef");
          if (function(_) {
            return !(gt(_) !== "[object Number]" || L && typeof _ == "object" && L in _);
          }(p))
            return Ct(jt(Number(p)));
          if (function(_) {
            if (!_ || typeof _ != "object" || !X)
              return !1;
            try {
              return X.call(_), !0;
            } catch {
            }
            return !1;
          }(p))
            return Ct(jt(X.call(p)));
          if (function(_) {
            return !(gt(_) !== "[object Boolean]" || L && typeof _ == "object" && L in _);
          }(p))
            return Ct(N.call(p));
          if (function(_) {
            return !(gt(_) !== "[object String]" || L && typeof _ == "object" && L in _);
          }(p))
            return Ct(jt(String(p)));
          if (typeof window < "u" && p === window)
            return "{ [object Window] }";
          if (p === w.g)
            return "{ [object globalThis] }";
          if (!function(_) {
            return !(gt(_) !== "[object Date]" || L && typeof _ == "object" && L in _);
          }(p) && !mt(p)) {
            var Ft = Kt(p, jt), ie = rt ? rt(p) === Object.prototype : p instanceof Object || p.constructor === Object, ae = p instanceof Object ? "" : "null prototype", se = !ie && L && Object(p) === p && L in p ? $.call(gt(p), 8, -1) : ae ? "Object" : "", kt = (ie || typeof p.constructor != "function" ? "" : p.constructor.name ? p.constructor.name + " " : "") + (se || ae ? "[" + W.call(M.call([], se || [], ae || []), ": ") + "] " : "");
            return Ft.length === 0 ? kt + "{}" : Ut ? kt + "{" + bt(Ft, Ut) + "}" : kt + "{ " + W.call(Ft, ", ") + " }";
          }
          return String(p);
        };
        var Ot = Object.prototype.hasOwnProperty || function(k) {
          return k in this;
        };
        function ct(k, p) {
          return Ot.call(k, p);
        }
        function gt(k) {
          return J.call(k);
        }
        function _t(k, p) {
          if (k.indexOf)
            return k.indexOf(p);
          for (var it = 0, nt = k.length; it < nt; it++)
            if (k[it] === p)
              return it;
          return -1;
        }
        function Tt(k, p) {
          if (k.length > p.maxStringLength) {
            var it = k.length - p.maxStringLength, nt = "... " + it + " more character" + (it > 1 ? "s" : "");
            return Tt($.call(k, 0, p.maxStringLength), p) + nt;
          }
          return tt(R.call(R.call(k, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, Lt), "single", p);
        }
        function Lt(k) {
          var p = k.charCodeAt(0), it = { 8: "b", 9: "t", 10: "n", 12: "f", 13: "r" }[p];
          return it ? "\\" + it : "\\x" + (p < 16 ? "0" : "") + P.call(p.toString(16));
        }
        function Ct(k) {
          return "Object(" + k + ")";
        }
        function zt(k) {
          return k + " { ? }";
        }
        function Vt(k, p, it, nt) {
          return k + " (" + p + ") {" + (nt ? bt(it, nt) : W.call(it, ", ")) + "}";
        }
        function bt(k, p) {
          if (k.length === 0)
            return "";
          var it = `
` + p.prev + p.base;
          return it + W.call(k, "," + it) + `
` + p.prev;
        }
        function Kt(k, p) {
          var it = wt(k), nt = [];
          if (it) {
            nt.length = k.length;
            for (var yt = 0; yt < k.length; yt++)
              nt[yt] = ct(k, yt) ? p(k[yt], k) : "";
          }
          var et, vt = typeof Y == "function" ? Y(k) : [];
          if (g) {
            et = {};
            for (var Pt = 0; Pt < vt.length; Pt++)
              et["$" + vt[Pt]] = vt[Pt];
          }
          for (var ft in k)
            ct(k, ft) && (it && String(Number(ft)) === ft && ft < k.length || g && et["$" + ft] instanceof Symbol || (Z.call(/[^\w$]/, ft) ? nt.push(p(ft, k) + ": " + p(k[ft], k)) : nt.push(ft + ": " + p(k[ft], k))));
          if (typeof Y == "function")
            for (var Rt = 0; Rt < vt.length; Rt++)
              H.call(k, vt[Rt]) && nt.push("[" + p(vt[Rt]) + "]: " + p(k[vt[Rt]], k));
          return nt;
        }
      }, 930: function(C) {
        class q extends Error {
          constructor() {
            super("Throttled function aborted"), this.name = "AbortError";
          }
        }
        C.exports = ({ limit: w, interval: d, strict: A }) => {
          if (!Number.isFinite(w))
            throw new TypeError("Expected `limit` to be a finite number");
          if (!Number.isFinite(d))
            throw new TypeError("Expected `interval` to be a finite number");
          const E = /* @__PURE__ */ new Map();
          let T = 0, I = 0;
          const y = [], O = A ? function() {
            const h = Date.now();
            if (y.length < w)
              return y.push(h), 0;
            const j = y.shift() + d;
            return h >= j ? (y.push(h), 0) : (y.push(j), j - h);
          } : function() {
            const h = Date.now();
            return h - T > d ? (I = 1, T = h, 0) : (I < w ? I++ : (T += d, I = 1), T - h);
          };
          return (h) => {
            const j = function(...U) {
              if (!j.isEnabled)
                return (async () => h.apply(this, U))();
              let m;
              return new Promise((N, J) => {
                m = setTimeout(() => {
                  N(h.apply(this, U)), E.delete(m);
                }, O()), E.set(m, J);
              });
            };
            return j.abort = () => {
              for (const U of E.keys())
                clearTimeout(U), E.get(U)(new q());
              E.clear(), y.splice(0, y.length);
            }, j.isEnabled = !0, j;
          };
        }, C.exports.AbortError = q;
      }, 504: function(C, q, w) {
        var d = w(750), A = w(300), E = w(365)(), T = w(502), I = d("%TypeError%"), y = d("%Math.floor%");
        C.exports = function(O, h) {
          if (typeof O != "function")
            throw new I("`fn` is not a function");
          if (typeof h != "number" || h < 0 || h > 4294967295 || y(h) !== h)
            throw new I("`length` must be a positive 32-bit integer");
          var j = arguments.length > 2 && !!arguments[2], U = !0, m = !0;
          if ("length" in O && T) {
            var N = T(O, "length");
            N && !N.configurable && (U = !1), N && !N.writable && (m = !1);
          }
          return (U || m || !j) && (E ? A(O, "length", h, !0, !0) : A(O, "length", h)), O;
        };
      }, 337: function(C, q, w) {
        var d = w(750), A = w(737), E = w(524), T = d("%TypeError%"), I = d("%WeakMap%", !0), y = d("%Map%", !0), O = A("WeakMap.prototype.get", !0), h = A("WeakMap.prototype.set", !0), j = A("WeakMap.prototype.has", !0), U = A("Map.prototype.get", !0), m = A("Map.prototype.set", !0), N = A("Map.prototype.has", !0), J = function(S, z) {
          for (var $, R = S; ($ = R.next) !== null; R = $)
            if ($.key === z)
              return R.next = $.next, $.next = S.next, S.next = $, $;
        };
        C.exports = function() {
          var S, z, $, R = { assert: function(P) {
            if (!R.has(P))
              throw new T("Side channel does not contain " + E(P));
          }, get: function(P) {
            if (I && P && (typeof P == "object" || typeof P == "function")) {
              if (S)
                return O(S, P);
            } else if (y) {
              if (z)
                return U(z, P);
            } else if ($)
              return function(Q, Z) {
                var M = J(Q, Z);
                return M && M.value;
              }($, P);
          }, has: function(P) {
            if (I && P && (typeof P == "object" || typeof P == "function")) {
              if (S)
                return j(S, P);
            } else if (y) {
              if (z)
                return N(z, P);
            } else if ($)
              return function(Q, Z) {
                return !!J(Q, Z);
              }($, P);
            return !1;
          }, set: function(P, Q) {
            I && P && (typeof P == "object" || typeof P == "function") ? (S || (S = new I()), h(S, P, Q)) : y ? (z || (z = new y()), m(z, P, Q)) : ($ || ($ = { key: {}, next: null }), function(Z, M, W) {
              var G = J(Z, M);
              G ? G.value = W : Z.next = { key: M, next: Z.next, value: W };
            }($, P, Q));
          } };
          return R;
        };
      }, 553: function() {
      } }, ge = {};
      function lt(C) {
        var q = ge[C];
        if (q !== void 0)
          return q.exports;
        var w = ge[C] = { exports: {} };
        return Wt[C].call(w.exports, w, w.exports, lt), w.exports;
      }
      lt.n = function(C) {
        var q = C && C.__esModule ? function() {
          return C.default;
        } : function() {
          return C;
        };
        return lt.d(q, { a: q }), q;
      }, lt.d = function(C, q) {
        for (var w in q)
          lt.o(q, w) && !lt.o(C, w) && Object.defineProperty(C, w, { enumerable: !0, get: q[w] });
      }, lt.g = function() {
        if (typeof globalThis == "object")
          return globalThis;
        try {
          return this || new Function("return this")();
        } catch {
          if (typeof window == "object")
            return window;
        }
      }(), lt.o = function(C, q) {
        return Object.prototype.hasOwnProperty.call(C, q);
      }, lt.r = function(C) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(C, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(C, "__esModule", { value: !0 });
      };
      var Pe = {};
      return function() {
        function C(t, e) {
          return function() {
            return t.apply(e, arguments);
          };
        }
        lt.r(Pe), lt.d(Pe, { createClient: function() {
          return Or;
        }, createGlobalOptions: function() {
          return Ge;
        } });
        const { toString: q } = Object.prototype, { getPrototypeOf: w } = Object, d = (A = /* @__PURE__ */ Object.create(null), (t) => {
          const e = q.call(t);
          return A[e] || (A[e] = e.slice(8, -1).toLowerCase());
        });
        var A;
        const E = (t) => (t = t.toLowerCase(), (e) => d(e) === t), T = (t) => (e) => typeof e === t, { isArray: I } = Array, y = T("undefined"), O = E("ArrayBuffer"), h = T("string"), j = T("function"), U = T("number"), m = (t) => t !== null && typeof t == "object", N = (t) => {
          if (d(t) !== "object")
            return !1;
          const e = w(t);
          return !(e !== null && e !== Object.prototype && Object.getPrototypeOf(e) !== null || Symbol.toStringTag in t || Symbol.iterator in t);
        }, J = E("Date"), S = E("File"), z = E("Blob"), $ = E("FileList"), R = E("URLSearchParams");
        function P(t, e, { allOwnKeys: r = !1 } = {}) {
          if (t == null)
            return;
          let n, o;
          if (typeof t != "object" && (t = [t]), I(t))
            for (n = 0, o = t.length; n < o; n++)
              e.call(null, t[n], n, t);
          else {
            const a = r ? Object.getOwnPropertyNames(t) : Object.keys(t), i = a.length;
            let l;
            for (n = 0; n < i; n++)
              l = a[n], e.call(null, t[l], l, t);
          }
        }
        function Q(t, e) {
          e = e.toLowerCase();
          const r = Object.keys(t);
          let n, o = r.length;
          for (; o-- > 0; )
            if (n = r[o], e === n.toLowerCase())
              return n;
          return null;
        }
        const Z = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : Er, M = (t) => !y(t) && t !== Z, W = (G = typeof Uint8Array < "u" && w(Uint8Array), (t) => G && t instanceof G);
        var G;
        const D = E("HTMLFormElement"), X = (({ hasOwnProperty: t }) => (e, r) => t.call(e, r))(Object.prototype), Y = E("RegExp"), x = (t, e) => {
          const r = Object.getOwnPropertyDescriptors(t), n = {};
          P(r, (o, a) => {
            let i;
            (i = e(o, a, t)) !== !1 && (n[a] = i || o);
          }), Object.defineProperties(t, n);
        }, g = "abcdefghijklmnopqrstuvwxyz", L = "0123456789", H = { DIGIT: L, ALPHA: g, ALPHA_DIGIT: g + g.toUpperCase() + L }, rt = E("AsyncFunction");
        var c = { isArray: I, isArrayBuffer: O, isBuffer: function(t) {
          return t !== null && !y(t) && t.constructor !== null && !y(t.constructor) && j(t.constructor.isBuffer) && t.constructor.isBuffer(t);
        }, isFormData: (t) => {
          let e;
          return t && (typeof FormData == "function" && t instanceof FormData || j(t.append) && ((e = d(t)) === "formdata" || e === "object" && j(t.toString) && t.toString() === "[object FormData]"));
        }, isArrayBufferView: function(t) {
          let e;
          return e = typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(t) : t && t.buffer && O(t.buffer), e;
        }, isString: h, isNumber: U, isBoolean: (t) => t === !0 || t === !1, isObject: m, isPlainObject: N, isUndefined: y, isDate: J, isFile: S, isBlob: z, isRegExp: Y, isFunction: j, isStream: (t) => m(t) && j(t.pipe), isURLSearchParams: R, isTypedArray: W, isFileList: $, forEach: P, merge: function t() {
          const { caseless: e } = M(this) && this || {}, r = {}, n = (o, a) => {
            const i = e && Q(r, a) || a;
            N(r[i]) && N(o) ? r[i] = t(r[i], o) : N(o) ? r[i] = t({}, o) : I(o) ? r[i] = o.slice() : r[i] = o;
          };
          for (let o = 0, a = arguments.length; o < a; o++)
            arguments[o] && P(arguments[o], n);
          return r;
        }, extend: (t, e, r, { allOwnKeys: n } = {}) => (P(e, (o, a) => {
          r && j(o) ? t[a] = C(o, r) : t[a] = o;
        }, { allOwnKeys: n }), t), trim: (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""), stripBOM: (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), inherits: (t, e, r, n) => {
          t.prototype = Object.create(e.prototype, n), t.prototype.constructor = t, Object.defineProperty(t, "super", { value: e.prototype }), r && Object.assign(t.prototype, r);
        }, toFlatObject: (t, e, r, n) => {
          let o, a, i;
          const l = {};
          if (e = e || {}, t == null)
            return e;
          do {
            for (o = Object.getOwnPropertyNames(t), a = o.length; a-- > 0; )
              i = o[a], n && !n(i, t, e) || l[i] || (e[i] = t[i], l[i] = !0);
            t = r !== !1 && w(t);
          } while (t && (!r || r(t, e)) && t !== Object.prototype);
          return e;
        }, kindOf: d, kindOfTest: E, endsWith: (t, e, r) => {
          t = String(t), (r === void 0 || r > t.length) && (r = t.length), r -= e.length;
          const n = t.indexOf(e, r);
          return n !== -1 && n === r;
        }, toArray: (t) => {
          if (!t)
            return null;
          if (I(t))
            return t;
          let e = t.length;
          if (!U(e))
            return null;
          const r = new Array(e);
          for (; e-- > 0; )
            r[e] = t[e];
          return r;
        }, forEachEntry: (t, e) => {
          const r = (t && t[Symbol.iterator]).call(t);
          let n;
          for (; (n = r.next()) && !n.done; ) {
            const o = n.value;
            e.call(t, o[0], o[1]);
          }
        }, matchAll: (t, e) => {
          let r;
          const n = [];
          for (; (r = t.exec(e)) !== null; )
            n.push(r);
          return n;
        }, isHTMLForm: D, hasOwnProperty: X, hasOwnProp: X, reduceDescriptors: x, freezeMethods: (t) => {
          x(t, (e, r) => {
            if (j(t) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
              return !1;
            const n = t[r];
            j(n) && (e.enumerable = !1, "writable" in e ? e.writable = !1 : e.set || (e.set = () => {
              throw Error("Can not rewrite read-only method '" + r + "'");
            }));
          });
        }, toObjectSet: (t, e) => {
          const r = {}, n = (o) => {
            o.forEach((a) => {
              r[a] = !0;
            });
          };
          return I(t) ? n(t) : n(String(t).split(e)), r;
        }, toCamelCase: (t) => t.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(e, r, n) {
          return r.toUpperCase() + n;
        }), noop: () => {
        }, toFiniteNumber: (t, e) => (t = +t, Number.isFinite(t) ? t : e), findKey: Q, global: Z, isContextDefined: M, ALPHABET: H, generateString: (t = 16, e = H.ALPHA_DIGIT) => {
          let r = "";
          const { length: n } = e;
          for (; t--; )
            r += e[Math.random() * n | 0];
          return r;
        }, isSpecCompliantForm: function(t) {
          return !!(t && j(t.append) && t[Symbol.toStringTag] === "FormData" && t[Symbol.iterator]);
        }, toJSONObject: (t) => {
          const e = new Array(10), r = (n, o) => {
            if (m(n)) {
              if (e.indexOf(n) >= 0)
                return;
              if (!("toJSON" in n)) {
                e[o] = n;
                const a = I(n) ? [] : {};
                return P(n, (i, l) => {
                  const u = r(i, o + 1);
                  !y(u) && (a[l] = u);
                }), e[o] = void 0, a;
              }
            }
            return n;
          };
          return r(t, 0);
        }, isAsyncFn: rt, isThenable: (t) => t && (m(t) || j(t)) && j(t.then) && j(t.catch) };
        function ot(t, e, r, n, o) {
          Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), r && (this.config = r), n && (this.request = n), o && (this.response = o);
        }
        c.inherits(ot, Error, { toJSON: function() {
          return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: c.toJSONObject(this.config), code: this.code, status: this.response && this.response.status ? this.response.status : null };
        } });
        const st = ot.prototype, At = {};
        ["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED", "ERR_NOT_SUPPORT", "ERR_INVALID_URL"].forEach((t) => {
          At[t] = { value: t };
        }), Object.defineProperties(ot, At), Object.defineProperty(st, "isAxiosError", { value: !0 }), ot.from = (t, e, r, n, o, a) => {
          const i = Object.create(st);
          return c.toFlatObject(t, i, function(l) {
            return l !== Error.prototype;
          }, (l) => l !== "isAxiosError"), ot.call(i, t.message, e, r, n, o), i.cause = t, i.name = t.name, a && Object.assign(i, a), i;
        };
        var tt = ot;
        function ht(t) {
          return c.isPlainObject(t) || c.isArray(t);
        }
        function wt(t) {
          return c.endsWith(t, "[]") ? t.slice(0, -2) : t;
        }
        function mt(t, e, r) {
          return t ? t.concat(e).map(function(n, o) {
            return n = wt(n), !r && o ? "[" + n + "]" : n;
          }).join(r ? "." : "") : e;
        }
        const Et = c.toFlatObject(c, {}, null, function(t) {
          return /^is[A-Z]/.test(t);
        });
        var Ot = function(t, e, r) {
          if (!c.isObject(t))
            throw new TypeError("target must be an object");
          e = e || new FormData();
          const n = (r = c.toFlatObject(r, { metaTokens: !0, dots: !1, indexes: !1 }, !1, function(b, F) {
            return !c.isUndefined(F[b]);
          })).metaTokens, o = r.visitor || s, a = r.dots, i = r.indexes, l = (r.Blob || typeof Blob < "u" && Blob) && c.isSpecCompliantForm(e);
          if (!c.isFunction(o))
            throw new TypeError("visitor must be a function");
          function u(b) {
            if (b === null)
              return "";
            if (c.isDate(b))
              return b.toISOString();
            if (!l && c.isBlob(b))
              throw new tt("Blob is not supported. Use a Buffer instead.");
            return c.isArrayBuffer(b) || c.isTypedArray(b) ? l && typeof Blob == "function" ? new Blob([b]) : Buffer.from(b) : b;
          }
          function s(b, F, B) {
            let K = b;
            if (b && !B && typeof b == "object") {
              if (c.endsWith(F, "{}"))
                F = n ? F : F.slice(0, -2), b = JSON.stringify(b);
              else if (c.isArray(b) && function(V) {
                return c.isArray(V) && !V.some(ht);
              }(b) || (c.isFileList(b) || c.endsWith(F, "[]")) && (K = c.toArray(b)))
                return F = wt(F), K.forEach(function(V, pt) {
                  !c.isUndefined(V) && V !== null && e.append(i === !0 ? mt([F], pt, a) : i === null ? F : F + "[]", u(V));
                }), !1;
            }
            return !!ht(b) || (e.append(mt(B, F, a), u(b)), !1);
          }
          const f = [], v = Object.assign(Et, { defaultVisitor: s, convertValue: u, isVisitable: ht });
          if (!c.isObject(t))
            throw new TypeError("data must be an object");
          return function b(F, B) {
            if (!c.isUndefined(F)) {
              if (f.indexOf(F) !== -1)
                throw Error("Circular reference detected in " + B.join("."));
              f.push(F), c.forEach(F, function(K, V) {
                (!(c.isUndefined(K) || K === null) && o.call(e, K, c.isString(V) ? V.trim() : V, B, v)) === !0 && b(K, B ? B.concat(V) : [V]);
              }), f.pop();
            }
          }(t), e;
        };
        function ct(t) {
          const e = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+", "%00": "\0" };
          return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(r) {
            return e[r];
          });
        }
        function gt(t, e) {
          this._pairs = [], t && Ot(t, this, e);
        }
        const _t = gt.prototype;
        _t.append = function(t, e) {
          this._pairs.push([t, e]);
        }, _t.toString = function(t) {
          const e = t ? function(r) {
            return t.call(this, r, ct);
          } : ct;
          return this._pairs.map(function(r) {
            return e(r[0]) + "=" + e(r[1]);
          }, "").join("&");
        };
        var Tt = gt;
        function Lt(t) {
          return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
        }
        function Ct(t, e, r) {
          if (!e)
            return t;
          const n = r && r.encode || Lt, o = r && r.serialize;
          let a;
          if (a = o ? o(e, r) : c.isURLSearchParams(e) ? e.toString() : new Tt(e, r).toString(n), a) {
            const i = t.indexOf("#");
            i !== -1 && (t = t.slice(0, i)), t += (t.indexOf("?") === -1 ? "?" : "&") + a;
          }
          return t;
        }
        var zt = class {
          constructor() {
            this.handlers = [];
          }
          use(t, e, r) {
            return this.handlers.push({ fulfilled: t, rejected: e, synchronous: !!r && r.synchronous, runWhen: r ? r.runWhen : null }), this.handlers.length - 1;
          }
          eject(t) {
            this.handlers[t] && (this.handlers[t] = null);
          }
          clear() {
            this.handlers && (this.handlers = []);
          }
          forEach(t) {
            c.forEach(this.handlers, function(e) {
              e !== null && t(e);
            });
          }
        }, Vt = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 }, bt = { isBrowser: !0, classes: { URLSearchParams: typeof URLSearchParams < "u" ? URLSearchParams : Tt, FormData: typeof FormData < "u" ? FormData : null, Blob: typeof Blob < "u" ? Blob : null }, isStandardBrowserEnv: (() => {
          let t;
          return (typeof navigator > "u" || (t = navigator.product) !== "ReactNative" && t !== "NativeScript" && t !== "NS") && typeof window < "u" && typeof document < "u";
        })(), isStandardBrowserWebWorkerEnv: typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function", protocols: ["http", "https", "file", "blob", "url", "data"] }, Kt = function(t) {
          function e(r, n, o, a) {
            let i = r[a++];
            const l = Number.isFinite(+i), u = a >= r.length;
            return i = !i && c.isArray(o) ? o.length : i, u ? (c.hasOwnProp(o, i) ? o[i] = [o[i], n] : o[i] = n, !l) : (o[i] && c.isObject(o[i]) || (o[i] = []), e(r, n, o[i], a) && c.isArray(o[i]) && (o[i] = function(s) {
              const f = {}, v = Object.keys(s);
              let b;
              const F = v.length;
              let B;
              for (b = 0; b < F; b++)
                B = v[b], f[B] = s[B];
              return f;
            }(o[i])), !l);
          }
          if (c.isFormData(t) && c.isFunction(t.entries)) {
            const r = {};
            return c.forEachEntry(t, (n, o) => {
              e(function(a) {
                return c.matchAll(/\w+|\[(\w*)]/g, a).map((i) => i[0] === "[]" ? "" : i[1] || i[0]);
              }(n), o, r, 0);
            }), r;
          }
          return null;
        };
        const k = { transitional: Vt, adapter: ["xhr", "http"], transformRequest: [function(t, e) {
          const r = e.getContentType() || "", n = r.indexOf("application/json") > -1, o = c.isObject(t);
          if (o && c.isHTMLForm(t) && (t = new FormData(t)), c.isFormData(t))
            return n && n ? JSON.stringify(Kt(t)) : t;
          if (c.isArrayBuffer(t) || c.isBuffer(t) || c.isStream(t) || c.isFile(t) || c.isBlob(t))
            return t;
          if (c.isArrayBufferView(t))
            return t.buffer;
          if (c.isURLSearchParams(t))
            return e.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
          let a;
          if (o) {
            if (r.indexOf("application/x-www-form-urlencoded") > -1)
              return function(i, l) {
                return Ot(i, new bt.classes.URLSearchParams(), Object.assign({ visitor: function(u, s, f, v) {
                  return bt.isNode && c.isBuffer(u) ? (this.append(s, u.toString("base64")), !1) : v.defaultVisitor.apply(this, arguments);
                } }, l));
              }(t, this.formSerializer).toString();
            if ((a = c.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
              const i = this.env && this.env.FormData;
              return Ot(a ? { "files[]": t } : t, i && new i(), this.formSerializer);
            }
          }
          return o || n ? (e.setContentType("application/json", !1), function(i, l, u) {
            if (c.isString(i))
              try {
                return (0, JSON.parse)(i), c.trim(i);
              } catch (s) {
                if (s.name !== "SyntaxError")
                  throw s;
              }
            return (0, JSON.stringify)(i);
          }(t)) : t;
        }], transformResponse: [function(t) {
          const e = this.transitional || k.transitional, r = e && e.forcedJSONParsing, n = this.responseType === "json";
          if (t && c.isString(t) && (r && !this.responseType || n)) {
            const o = !(e && e.silentJSONParsing) && n;
            try {
              return JSON.parse(t);
            } catch (a) {
              if (o)
                throw a.name === "SyntaxError" ? tt.from(a, tt.ERR_BAD_RESPONSE, this, null, this.response) : a;
            }
          }
          return t;
        }], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, env: { FormData: bt.classes.FormData, Blob: bt.classes.Blob }, validateStatus: function(t) {
          return t >= 200 && t < 300;
        }, headers: { common: { Accept: "application/json, text/plain, */*", "Content-Type": void 0 } } };
        c.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
          k.headers[t] = {};
        });
        var p = k;
        const it = c.toObjectSet(["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"]), nt = Symbol("internals");
        function yt(t) {
          return t && String(t).trim().toLowerCase();
        }
        function et(t) {
          return t === !1 || t == null ? t : c.isArray(t) ? t.map(et) : String(t);
        }
        function vt(t, e, r, n, o) {
          return c.isFunction(n) ? n.call(this, e, r) : (o && (e = r), c.isString(e) ? c.isString(n) ? e.indexOf(n) !== -1 : c.isRegExp(n) ? n.test(e) : void 0 : void 0);
        }
        class Pt {
          constructor(e) {
            e && this.set(e);
          }
          set(e, r, n) {
            const o = this;
            function a(l, u, s) {
              const f = yt(u);
              if (!f)
                throw new Error("header name must be a non-empty string");
              const v = c.findKey(o, f);
              (!v || o[v] === void 0 || s === !0 || s === void 0 && o[v] !== !1) && (o[v || u] = et(l));
            }
            const i = (l, u) => c.forEach(l, (s, f) => a(s, f, u));
            return c.isPlainObject(e) || e instanceof this.constructor ? i(e, r) : c.isString(e) && (e = e.trim()) && !/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim()) ? i(((l) => {
              const u = {};
              let s, f, v;
              return l && l.split(`
`).forEach(function(b) {
                v = b.indexOf(":"), s = b.substring(0, v).trim().toLowerCase(), f = b.substring(v + 1).trim(), !s || u[s] && it[s] || (s === "set-cookie" ? u[s] ? u[s].push(f) : u[s] = [f] : u[s] = u[s] ? u[s] + ", " + f : f);
              }), u;
            })(e), r) : e != null && a(r, e, n), this;
          }
          get(e, r) {
            if (e = yt(e)) {
              const n = c.findKey(this, e);
              if (n) {
                const o = this[n];
                if (!r)
                  return o;
                if (r === !0)
                  return function(a) {
                    const i = /* @__PURE__ */ Object.create(null), l = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
                    let u;
                    for (; u = l.exec(a); )
                      i[u[1]] = u[2];
                    return i;
                  }(o);
                if (c.isFunction(r))
                  return r.call(this, o, n);
                if (c.isRegExp(r))
                  return r.exec(o);
                throw new TypeError("parser must be boolean|regexp|function");
              }
            }
          }
          has(e, r) {
            if (e = yt(e)) {
              const n = c.findKey(this, e);
              return !(!n || this[n] === void 0 || r && !vt(0, this[n], n, r));
            }
            return !1;
          }
          delete(e, r) {
            const n = this;
            let o = !1;
            function a(i) {
              if (i = yt(i)) {
                const l = c.findKey(n, i);
                !l || r && !vt(0, n[l], l, r) || (delete n[l], o = !0);
              }
            }
            return c.isArray(e) ? e.forEach(a) : a(e), o;
          }
          clear(e) {
            const r = Object.keys(this);
            let n = r.length, o = !1;
            for (; n--; ) {
              const a = r[n];
              e && !vt(0, this[a], a, e, !0) || (delete this[a], o = !0);
            }
            return o;
          }
          normalize(e) {
            const r = this, n = {};
            return c.forEach(this, (o, a) => {
              const i = c.findKey(n, a);
              if (i)
                return r[i] = et(o), void delete r[a];
              const l = e ? function(u) {
                return u.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (s, f, v) => f.toUpperCase() + v);
              }(a) : String(a).trim();
              l !== a && delete r[a], r[l] = et(o), n[l] = !0;
            }), this;
          }
          concat(...e) {
            return this.constructor.concat(this, ...e);
          }
          toJSON(e) {
            const r = /* @__PURE__ */ Object.create(null);
            return c.forEach(this, (n, o) => {
              n != null && n !== !1 && (r[o] = e && c.isArray(n) ? n.join(", ") : n);
            }), r;
          }
          [Symbol.iterator]() {
            return Object.entries(this.toJSON())[Symbol.iterator]();
          }
          toString() {
            return Object.entries(this.toJSON()).map(([e, r]) => e + ": " + r).join(`
`);
          }
          get [Symbol.toStringTag]() {
            return "AxiosHeaders";
          }
          static from(e) {
            return e instanceof this ? e : new this(e);
          }
          static concat(e, ...r) {
            const n = new this(e);
            return r.forEach((o) => n.set(o)), n;
          }
          static accessor(e) {
            const r = (this[nt] = this[nt] = { accessors: {} }).accessors, n = this.prototype;
            function o(a) {
              const i = yt(a);
              r[i] || (function(l, u) {
                const s = c.toCamelCase(" " + u);
                ["get", "set", "has"].forEach((f) => {
                  Object.defineProperty(l, f + s, { value: function(v, b, F) {
                    return this[f].call(this, u, v, b, F);
                  }, configurable: !0 });
                });
              }(n, a), r[i] = !0);
            }
            return c.isArray(e) ? e.forEach(o) : o(e), this;
          }
        }
        Pt.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]), c.reduceDescriptors(Pt.prototype, ({ value: t }, e) => {
          let r = e[0].toUpperCase() + e.slice(1);
          return { get: () => t, set(n) {
            this[r] = n;
          } };
        }), c.freezeMethods(Pt);
        var ft = Pt;
        function Rt(t, e) {
          const r = this || p, n = e || r, o = ft.from(n.headers);
          let a = n.data;
          return c.forEach(t, function(i) {
            a = i.call(r, a, o.normalize(), e ? e.status : void 0);
          }), o.normalize(), a;
        }
        function ee(t) {
          return !(!t || !t.__CANCEL__);
        }
        function Ht(t, e, r) {
          tt.call(this, t ?? "canceled", tt.ERR_CANCELED, e, r), this.name = "CanceledError";
        }
        c.inherits(Ht, tt, { __CANCEL__: !0 });
        var Ut = Ht, jt = bt.isStandardBrowserEnv ? { write: function(t, e, r, n, o, a) {
          const i = [];
          i.push(t + "=" + encodeURIComponent(e)), c.isNumber(r) && i.push("expires=" + new Date(r).toGMTString()), c.isString(n) && i.push("path=" + n), c.isString(o) && i.push("domain=" + o), a === !0 && i.push("secure"), document.cookie = i.join("; ");
        }, read: function(t) {
          const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
          return e ? decodeURIComponent(e[3]) : null;
        }, remove: function(t) {
          this.write(t, "", Date.now() - 864e5);
        } } : { write: function() {
        }, read: function() {
          return null;
        }, remove: function() {
        } };
        function ue(t, e) {
          return t && !/^([a-z][a-z\d+\-.]*:)?\/\//i.test(e) ? function(r, n) {
            return n ? r.replace(/\/+$/, "") + "/" + n.replace(/^\/+/, "") : r;
          }(t, e) : e;
        }
        var be = bt.isStandardBrowserEnv ? function() {
          const t = /(msie|trident)/i.test(navigator.userAgent), e = document.createElement("a");
          let r;
          function n(o) {
            let a = o;
            return t && (e.setAttribute("href", a), a = e.href), e.setAttribute("href", a), { href: e.href, protocol: e.protocol ? e.protocol.replace(/:$/, "") : "", host: e.host, search: e.search ? e.search.replace(/^\?/, "") : "", hash: e.hash ? e.hash.replace(/^#/, "") : "", hostname: e.hostname, port: e.port, pathname: e.pathname.charAt(0) === "/" ? e.pathname : "/" + e.pathname };
          }
          return r = n(window.location.href), function(o) {
            const a = c.isString(o) ? n(o) : o;
            return a.protocol === r.protocol && a.host === r.host;
          };
        }() : function() {
          return !0;
        };
        function le(t, e) {
          let r = 0;
          const n = function(o, a) {
            o = o || 10;
            const i = new Array(o), l = new Array(o);
            let u, s = 0, f = 0;
            return a = a !== void 0 ? a : 1e3, function(v) {
              const b = Date.now(), F = l[f];
              u || (u = b), i[s] = v, l[s] = b;
              let B = f, K = 0;
              for (; B !== s; )
                K += i[B++], B %= o;
              if (s = (s + 1) % o, s === f && (f = (f + 1) % o), b - u < a)
                return;
              const V = F && b - F;
              return V ? Math.round(1e3 * K / V) : void 0;
            };
          }(50, 250);
          return (o) => {
            const a = o.loaded, i = o.lengthComputable ? o.total : void 0, l = a - r, u = n(l);
            r = a;
            const s = { loaded: a, total: i, progress: i ? a / i : void 0, bytes: l, rate: u || void 0, estimated: u && i && a <= i ? (i - a) / u : void 0, event: o };
            s[e ? "download" : "upload"] = !0, t(s);
          };
        }
        const $t = { http: null, xhr: typeof XMLHttpRequest < "u" && function(t) {
          return new Promise(function(e, r) {
            let n = t.data;
            const o = ft.from(t.headers).normalize(), a = t.responseType;
            let i, l;
            function u() {
              t.cancelToken && t.cancelToken.unsubscribe(i), t.signal && t.signal.removeEventListener("abort", i);
            }
            c.isFormData(n) && (bt.isStandardBrowserEnv || bt.isStandardBrowserWebWorkerEnv ? o.setContentType(!1) : o.getContentType(/^\s*multipart\/form-data/) ? c.isString(l = o.getContentType()) && o.setContentType(l.replace(/^\s*(multipart\/form-data);+/, "$1")) : o.setContentType("multipart/form-data"));
            let s = new XMLHttpRequest();
            if (t.auth) {
              const F = t.auth.username || "", B = t.auth.password ? unescape(encodeURIComponent(t.auth.password)) : "";
              o.set("Authorization", "Basic " + btoa(F + ":" + B));
            }
            const f = ue(t.baseURL, t.url);
            function v() {
              if (!s)
                return;
              const F = ft.from("getAllResponseHeaders" in s && s.getAllResponseHeaders());
              (function(B, K, V) {
                const pt = V.config.validateStatus;
                V.status && pt && !pt(V.status) ? K(new tt("Request failed with status code " + V.status, [tt.ERR_BAD_REQUEST, tt.ERR_BAD_RESPONSE][Math.floor(V.status / 100) - 4], V.config, V.request, V)) : B(V);
              })(function(B) {
                e(B), u();
              }, function(B) {
                r(B), u();
              }, { data: a && a !== "text" && a !== "json" ? s.response : s.responseText, status: s.status, statusText: s.statusText, headers: F, config: t, request: s }), s = null;
            }
            if (s.open(t.method.toUpperCase(), Ct(f, t.params, t.paramsSerializer), !0), s.timeout = t.timeout, "onloadend" in s ? s.onloadend = v : s.onreadystatechange = function() {
              s && s.readyState === 4 && (s.status !== 0 || s.responseURL && s.responseURL.indexOf("file:") === 0) && setTimeout(v);
            }, s.onabort = function() {
              s && (r(new tt("Request aborted", tt.ECONNABORTED, t, s)), s = null);
            }, s.onerror = function() {
              r(new tt("Network Error", tt.ERR_NETWORK, t, s)), s = null;
            }, s.ontimeout = function() {
              let F = t.timeout ? "timeout of " + t.timeout + "ms exceeded" : "timeout exceeded";
              const B = t.transitional || Vt;
              t.timeoutErrorMessage && (F = t.timeoutErrorMessage), r(new tt(F, B.clarifyTimeoutError ? tt.ETIMEDOUT : tt.ECONNABORTED, t, s)), s = null;
            }, bt.isStandardBrowserEnv) {
              const F = be(f) && t.xsrfCookieName && jt.read(t.xsrfCookieName);
              F && o.set(t.xsrfHeaderName, F);
            }
            n === void 0 && o.setContentType(null), "setRequestHeader" in s && c.forEach(o.toJSON(), function(F, B) {
              s.setRequestHeader(B, F);
            }), c.isUndefined(t.withCredentials) || (s.withCredentials = !!t.withCredentials), a && a !== "json" && (s.responseType = t.responseType), typeof t.onDownloadProgress == "function" && s.addEventListener("progress", le(t.onDownloadProgress, !0)), typeof t.onUploadProgress == "function" && s.upload && s.upload.addEventListener("progress", le(t.onUploadProgress)), (t.cancelToken || t.signal) && (i = (F) => {
              s && (r(!F || F.type ? new Ut(null, t, s) : F), s.abort(), s = null);
            }, t.cancelToken && t.cancelToken.subscribe(i), t.signal && (t.signal.aborted ? i() : t.signal.addEventListener("abort", i)));
            const b = function(F) {
              const B = /^([-+\w]{1,25})(:?\/\/|:)/.exec(F);
              return B && B[1] || "";
            }(f);
            b && bt.protocols.indexOf(b) === -1 ? r(new tt("Unsupported protocol " + b + ":", tt.ERR_BAD_REQUEST, t)) : s.send(n || null);
          });
        } };
        c.forEach($t, (t, e) => {
          if (t) {
            try {
              Object.defineProperty(t, "name", { value: e });
            } catch {
            }
            Object.defineProperty(t, "adapterName", { value: e });
          }
        });
        const re = (t) => `- ${t}`, ne = (t) => c.isFunction(t) || t === null || t === !1;
        var oe = { getAdapter: (t) => {
          t = c.isArray(t) ? t : [t];
          const { length: e } = t;
          let r, n;
          const o = {};
          for (let a = 0; a < e; a++) {
            let i;
            if (r = t[a], n = r, !ne(r) && (n = $t[(i = String(r)).toLowerCase()], n === void 0))
              throw new tt(`Unknown adapter '${i}'`);
            if (n)
              break;
            o[i || "#" + a] = n;
          }
          if (!n) {
            const a = Object.entries(o).map(([l, u]) => `adapter ${l} ` + (u === !1 ? "is not supported by the environment" : "is not available in the build"));
            let i = e ? a.length > 1 ? `since :
` + a.map(re).join(`
`) : " " + re(a[0]) : "as no adapter specified";
            throw new tt("There is no suitable adapter to dispatch the request " + i, "ERR_NOT_SUPPORT");
          }
          return n;
        }, adapters: $t };
        function Qt(t) {
          if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
            throw new Ut(null, t);
        }
        function fe(t) {
          return Qt(t), t.headers = ft.from(t.headers), t.data = Rt.call(t, t.transformRequest), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), oe.getAdapter(t.adapter || p.adapter)(t).then(function(e) {
            return Qt(t), e.data = Rt.call(t, t.transformResponse, e), e.headers = ft.from(e.headers), e;
          }, function(e) {
            return ee(e) || (Qt(t), e && e.response && (e.response.data = Rt.call(t, t.transformResponse, e.response), e.response.headers = ft.from(e.response.headers))), Promise.reject(e);
          });
        }
        const pe = (t) => t instanceof ft ? t.toJSON() : t;
        function Ft(t, e) {
          e = e || {};
          const r = {};
          function n(s, f, v) {
            return c.isPlainObject(s) && c.isPlainObject(f) ? c.merge.call({ caseless: v }, s, f) : c.isPlainObject(f) ? c.merge({}, f) : c.isArray(f) ? f.slice() : f;
          }
          function o(s, f, v) {
            return c.isUndefined(f) ? c.isUndefined(s) ? void 0 : n(void 0, s, v) : n(s, f, v);
          }
          function a(s, f) {
            if (!c.isUndefined(f))
              return n(void 0, f);
          }
          function i(s, f) {
            return c.isUndefined(f) ? c.isUndefined(s) ? void 0 : n(void 0, s) : n(void 0, f);
          }
          function l(s, f, v) {
            return v in e ? n(s, f) : v in t ? n(void 0, s) : void 0;
          }
          const u = { url: a, method: a, data: a, baseURL: i, transformRequest: i, transformResponse: i, paramsSerializer: i, timeout: i, timeoutMessage: i, withCredentials: i, adapter: i, responseType: i, xsrfCookieName: i, xsrfHeaderName: i, onUploadProgress: i, onDownloadProgress: i, decompress: i, maxContentLength: i, maxBodyLength: i, beforeRedirect: i, transport: i, httpAgent: i, httpsAgent: i, cancelToken: i, socketPath: i, responseEncoding: i, validateStatus: l, headers: (s, f) => o(pe(s), pe(f), !0) };
          return c.forEach(Object.keys(Object.assign({}, t, e)), function(s) {
            const f = u[s] || o, v = f(t[s], e[s], s);
            c.isUndefined(v) && f !== l || (r[s] = v);
          }), r;
        }
        const ie = {};
        ["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
          ie[t] = function(r) {
            return typeof r === t || "a" + (e < 1 ? "n " : " ") + t;
          };
        });
        const ae = {};
        ie.transitional = function(t, e, r) {
          function n(o, a) {
            return "[Axios v1.6.0] Transitional option '" + o + "'" + a + (r ? ". " + r : "");
          }
          return (o, a, i) => {
            if (t === !1)
              throw new tt(n(a, " has been removed" + (e ? " in " + e : "")), tt.ERR_DEPRECATED);
            return e && !ae[a] && (ae[a] = !0, console.warn(n(a, " has been deprecated since v" + e + " and will be removed in the near future"))), !t || t(o, a, i);
          };
        };
        var se = { assertOptions: function(t, e, r) {
          if (typeof t != "object")
            throw new tt("options must be an object", tt.ERR_BAD_OPTION_VALUE);
          const n = Object.keys(t);
          let o = n.length;
          for (; o-- > 0; ) {
            const a = n[o], i = e[a];
            if (i) {
              const l = t[a], u = l === void 0 || i(l, a, t);
              if (u !== !0)
                throw new tt("option " + a + " must be " + u, tt.ERR_BAD_OPTION_VALUE);
            } else if (r !== !0)
              throw new tt("Unknown option " + a, tt.ERR_BAD_OPTION);
          }
        }, validators: ie };
        const kt = se.validators;
        class _ {
          constructor(e) {
            this.defaults = e, this.interceptors = { request: new zt(), response: new zt() };
          }
          request(e, r) {
            typeof e == "string" ? (r = r || {}).url = e : r = e || {}, r = Ft(this.defaults, r);
            const { transitional: n, paramsSerializer: o, headers: a } = r;
            n !== void 0 && se.assertOptions(n, { silentJSONParsing: kt.transitional(kt.boolean), forcedJSONParsing: kt.transitional(kt.boolean), clarifyTimeoutError: kt.transitional(kt.boolean) }, !1), o != null && (c.isFunction(o) ? r.paramsSerializer = { serialize: o } : se.assertOptions(o, { encode: kt.function, serialize: kt.function }, !0)), r.method = (r.method || this.defaults.method || "get").toLowerCase();
            let i = a && c.merge(a.common, a[r.method]);
            a && c.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (B) => {
              delete a[B];
            }), r.headers = ft.concat(i, a);
            const l = [];
            let u = !0;
            this.interceptors.request.forEach(function(B) {
              typeof B.runWhen == "function" && B.runWhen(r) === !1 || (u = u && B.synchronous, l.unshift(B.fulfilled, B.rejected));
            });
            const s = [];
            let f;
            this.interceptors.response.forEach(function(B) {
              s.push(B.fulfilled, B.rejected);
            });
            let v, b = 0;
            if (!u) {
              const B = [fe.bind(this), void 0];
              for (B.unshift.apply(B, l), B.push.apply(B, s), v = B.length, f = Promise.resolve(r); b < v; )
                f = f.then(B[b++], B[b++]);
              return f;
            }
            v = l.length;
            let F = r;
            for (b = 0; b < v; ) {
              const B = l[b++], K = l[b++];
              try {
                F = B(F);
              } catch (V) {
                K.call(this, V);
                break;
              }
            }
            try {
              f = fe.call(this, F);
            } catch (B) {
              return Promise.reject(B);
            }
            for (b = 0, v = s.length; b < v; )
              f = f.then(s[b++], s[b++]);
            return f;
          }
          getUri(e) {
            return Ct(ue((e = Ft(this.defaults, e)).baseURL, e.url), e.params, e.paramsSerializer);
          }
        }
        c.forEach(["delete", "get", "head", "options"], function(t) {
          _.prototype[t] = function(e, r) {
            return this.request(Ft(r || {}, { method: t, url: e, data: (r || {}).data }));
          };
        }), c.forEach(["post", "put", "patch"], function(t) {
          function e(r) {
            return function(n, o, a) {
              return this.request(Ft(a || {}, { method: t, headers: r ? { "Content-Type": "multipart/form-data" } : {}, url: n, data: o }));
            };
          }
          _.prototype[t] = e(), _.prototype[t + "Form"] = e(!0);
        });
        var at = _;
        class Bt {
          constructor(e) {
            if (typeof e != "function")
              throw new TypeError("executor must be a function.");
            let r;
            this.promise = new Promise(function(o) {
              r = o;
            });
            const n = this;
            this.promise.then((o) => {
              if (!n._listeners)
                return;
              let a = n._listeners.length;
              for (; a-- > 0; )
                n._listeners[a](o);
              n._listeners = null;
            }), this.promise.then = (o) => {
              let a;
              const i = new Promise((l) => {
                n.subscribe(l), a = l;
              }).then(o);
              return i.cancel = function() {
                n.unsubscribe(a);
              }, i;
            }, e(function(o, a, i) {
              n.reason || (n.reason = new Ut(o, a, i), r(n.reason));
            });
          }
          throwIfRequested() {
            if (this.reason)
              throw this.reason;
          }
          subscribe(e) {
            this.reason ? e(this.reason) : this._listeners ? this._listeners.push(e) : this._listeners = [e];
          }
          unsubscribe(e) {
            if (!this._listeners)
              return;
            const r = this._listeners.indexOf(e);
            r !== -1 && this._listeners.splice(r, 1);
          }
          static source() {
            let e;
            return { token: new Bt(function(r) {
              e = r;
            }), cancel: e };
          }
        }
        var ve = Bt;
        const Re = { Continue: 100, SwitchingProtocols: 101, Processing: 102, EarlyHints: 103, Ok: 200, Created: 201, Accepted: 202, NonAuthoritativeInformation: 203, NoContent: 204, ResetContent: 205, PartialContent: 206, MultiStatus: 207, AlreadyReported: 208, ImUsed: 226, MultipleChoices: 300, MovedPermanently: 301, Found: 302, SeeOther: 303, NotModified: 304, UseProxy: 305, Unused: 306, TemporaryRedirect: 307, PermanentRedirect: 308, BadRequest: 400, Unauthorized: 401, PaymentRequired: 402, Forbidden: 403, NotFound: 404, MethodNotAllowed: 405, NotAcceptable: 406, ProxyAuthenticationRequired: 407, RequestTimeout: 408, Conflict: 409, Gone: 410, LengthRequired: 411, PreconditionFailed: 412, PayloadTooLarge: 413, UriTooLong: 414, UnsupportedMediaType: 415, RangeNotSatisfiable: 416, ExpectationFailed: 417, ImATeapot: 418, MisdirectedRequest: 421, UnprocessableEntity: 422, Locked: 423, FailedDependency: 424, TooEarly: 425, UpgradeRequired: 426, PreconditionRequired: 428, TooManyRequests: 429, RequestHeaderFieldsTooLarge: 431, UnavailableForLegalReasons: 451, InternalServerError: 500, NotImplemented: 501, BadGateway: 502, ServiceUnavailable: 503, GatewayTimeout: 504, HttpVersionNotSupported: 505, VariantAlsoNegotiates: 506, InsufficientStorage: 507, LoopDetected: 508, NotExtended: 510, NetworkAuthenticationRequired: 511 };
        Object.entries(Re).forEach(([t, e]) => {
          Re[e] = t;
        });
        var tr = Re;
        const dt = function t(e) {
          const r = new at(e), n = C(at.prototype.request, r);
          return c.extend(n, at.prototype, r, { allOwnKeys: !0 }), c.extend(n, r, null, { allOwnKeys: !0 }), n.create = function(o) {
            return t(Ft(e, o));
          }, n;
        }(p);
        dt.Axios = at, dt.CanceledError = Ut, dt.CancelToken = ve, dt.isCancel = ee, dt.VERSION = "1.6.0", dt.toFormData = Ot, dt.AxiosError = tt, dt.Cancel = dt.CanceledError, dt.all = function(t) {
          return Promise.all(t);
        }, dt.spread = function(t) {
          return function(e) {
            return t.apply(null, e);
          };
        }, dt.isAxiosError = function(t) {
          return c.isObject(t) && t.isAxiosError === !0;
        }, dt.mergeConfig = Ft, dt.AxiosHeaders = ft, dt.formToJSON = (t) => Kt(c.isHTMLForm(t) ? new FormData(t) : t), dt.getAdapter = oe.getAdapter, dt.HttpStatusCode = tr, dt.default = dt;
        var er = dt, rr = lt(581), we = lt.n(rr), nr = lt(122), or = lt.n(nr), ir = lt(451), Be = lt.n(ir), ar = lt(930), sr = lt.n(ar), cr = lt(261), ke = lt.n(cr);
        function Ie(t, e) {
          var r = Object.keys(t);
          if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(t);
            e && (n = n.filter(function(o) {
              return Object.getOwnPropertyDescriptor(t, o).enumerable;
            })), r.push.apply(r, n);
          }
          return r;
        }
        function Oe(t) {
          for (var e = 1; e < arguments.length; e++) {
            var r = arguments[e] != null ? arguments[e] : {};
            e % 2 ? Ie(Object(r), !0).forEach(function(n) {
              var o, a, i;
              o = t, a = n, i = r[n], (a = function(l) {
                var u = function(s, f) {
                  if (typeof s != "object" || s === null)
                    return s;
                  var v = s[Symbol.toPrimitive];
                  if (v !== void 0) {
                    var b = v.call(s, "string");
                    if (typeof b != "object")
                      return b;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                  }
                  return String(s);
                }(l);
                return typeof u == "symbol" ? u : String(u);
              }(a)) in o ? Object.defineProperty(o, a, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : o[a] = i;
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ie(Object(r)).forEach(function(n) {
              Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
            });
          }
          return t;
        }
        function Se(t) {
          return Se = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
            return typeof e;
          } : function(e) {
            return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, Se(t);
        }
        function Te() {
          Te = function(o, a) {
            return new r(o, void 0, a);
          };
          var t = RegExp.prototype, e = /* @__PURE__ */ new WeakMap();
          function r(o, a, i) {
            var l = new RegExp(o, a);
            return e.set(l, i || e.get(o)), Ae(l, r.prototype);
          }
          function n(o, a) {
            var i = e.get(a);
            return Object.keys(i).reduce(function(l, u) {
              var s = i[u];
              if (typeof s == "number")
                l[u] = o[s];
              else {
                for (var f = 0; o[s[f]] === void 0 && f + 1 < s.length; )
                  f++;
                l[u] = o[s[f]];
              }
              return l;
            }, /* @__PURE__ */ Object.create(null));
          }
          return function(o, a) {
            if (typeof a != "function" && a !== null)
              throw new TypeError("Super expression must either be null or a function");
            o.prototype = Object.create(a && a.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), a && Ae(o, a);
          }(r, RegExp), r.prototype.exec = function(o) {
            var a = t.exec.call(this, o);
            if (a) {
              a.groups = n(a, this);
              var i = a.indices;
              i && (i.groups = n(i, this));
            }
            return a;
          }, r.prototype[Symbol.replace] = function(o, a) {
            if (typeof a == "string") {
              var i = e.get(this);
              return t[Symbol.replace].call(this, o, a.replace(/\$<([^>]+)>/g, function(u, s) {
                var f = i[s];
                return "$" + (Array.isArray(f) ? f.join("$") : f);
              }));
            }
            if (typeof a == "function") {
              var l = this;
              return t[Symbol.replace].call(this, o, function() {
                var u = arguments;
                return typeof u[u.length - 1] != "object" && (u = [].slice.call(u)).push(n(u, l)), a.apply(this, u);
              });
            }
            return t[Symbol.replace].call(this, o, a);
          }, Te.apply(this, arguments);
        }
        function Ae(t, e) {
          return Ae = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
            return r.__proto__ = n, r;
          }, Ae(t, e);
        }
        function De(t, e) {
          if (t) {
            if (typeof t == "string")
              return Me(t, e);
            var r = Object.prototype.toString.call(t).slice(8, -1);
            return r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set" ? Array.from(t) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Me(t, e) : void 0;
          }
        }
        function Me(t, e) {
          (e == null || e > t.length) && (e = t.length);
          for (var r = 0, n = new Array(e); r < e; r++)
            n[r] = t[r];
          return n;
        }
        function Le() {
        }
        var ur = function(t) {
          return new Promise(function(e) {
            setTimeout(e, t);
          });
        }, lr = function(t) {
          return Math.pow(Math.SQRT2, t);
        }, Ue = Te(/(\d+)(%)/, { value: 1 });
        function Ne(t) {
          var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 7, r = e;
          if (Ue.test(t)) {
            var n, o = (n = t.match(Ue)) === null || n === void 0 ? void 0 : n.groups;
            if (o && o.value) {
              var a = parseInt(o.value) / 100;
              r = Math.round(e * a);
            }
          }
          return Math.min(30, Math.max(1, r));
        }
        function qe(t, e) {
          return e("info", "Throttle request to ".concat(t, "/s")), sr()({ limit: t, interval: 1e3, strict: !1 });
        }
        var fr = function(t) {
          var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "auto", r = t.defaults.logHandler, n = r === void 0 ? Le : r, o = Be()(e) ? Ne(e) : Ne("auto", e), a = qe(o, n), i = !1, l = t.interceptors.request.use(function(s) {
            return a(function() {
              return s;
            })();
          }, function(s) {
            return Promise.reject(s);
          }), u = t.interceptors.response.use(function(s) {
            if (!i && Be()(e) && (e === "auto" || Ue.test(e)) && s.headers && s.headers["x-contentful-ratelimit-second-limit"]) {
              var f = parseInt(s.headers["x-contentful-ratelimit-second-limit"]), v = Ne(e, f);
              v !== o && (l && t.interceptors.request.eject(l), o = v, a = qe(v, n), l = t.interceptors.request.use(function(b) {
                return a(function() {
                  return b;
                })();
              }, function(b) {
                return Promise.reject(b);
              })), i = !0;
            }
            return s;
          }, function(s) {
            return Promise.reject(s);
          });
          return function() {
            t.interceptors.request.eject(l), t.interceptors.response.eject(u);
          };
        }, pr = /^(?!\w+:\/\/)([^\s:]+\.?[^\s:]+)(?::(\d+))?(?!:)$/;
        function We(t, e) {
          var r = Oe(Oe({}, { insecure: !1, retryOnError: !0, logHandler: function(K, V) {
            if (K === "error" && V) {
              var pt = [V.name, V.message].filter(function(Nt) {
                return Nt;
              }).join(" - ");
              return console.error("[error] ".concat(pt)), void console.error(V);
            }
            console.log("[".concat(K, "] ").concat(V));
          }, headers: {}, httpAgent: !1, httpsAgent: !1, timeout: 3e4, throttle: 0, basePath: "", adapter: void 0, maxContentLength: 1073741824, maxBodyLength: 1073741824 }), e);
          if (!r.accessToken) {
            var n = new TypeError("Expected parameter accessToken");
            throw r.logHandler("error", n), n;
          }
          var o, a, i = r.insecure ? "http" : "https", l = r.space ? "".concat(r.space, "/") : "", u = r.defaultHostname, s = r.insecure ? 80 : 443;
          if (r.host && pr.test(r.host)) {
            var f = r.host.split(":");
            if (f.length === 2) {
              var v = (a = 2, function(K) {
                if (Array.isArray(K))
                  return K;
              }(o = f) || function(K, V) {
                var pt = K == null ? null : typeof Symbol < "u" && K[Symbol.iterator] || K["@@iterator"];
                if (pt != null) {
                  var Nt, Gt, Dt, It, ut = [], St = !0, xt = !1;
                  try {
                    if (Dt = (pt = pt.call(K)).next, V === 0) {
                      if (Object(pt) !== pt)
                        return;
                      St = !1;
                    } else
                      for (; !(St = (Nt = Dt.call(pt)).done) && (ut.push(Nt.value), ut.length !== V); St = !0)
                        ;
                  } catch (Mt) {
                    xt = !0, Gt = Mt;
                  } finally {
                    try {
                      if (!St && pt.return != null && (It = pt.return(), Object(It) !== It))
                        return;
                    } finally {
                      if (xt)
                        throw Gt;
                    }
                  }
                  return ut;
                }
              }(o, a) || De(o, a) || function() {
                throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }());
              u = v[0], s = v[1];
            } else
              u = f[0];
          }
          r.basePath && (r.basePath = "/".concat(r.basePath.split("/").filter(Boolean).join("/")));
          var b = e.baseURL || "".concat(i, "://").concat(u, ":").concat(s).concat(r.basePath, "/spaces/").concat(l);
          r.headers.Authorization || typeof r.accessToken == "function" || (r.headers.Authorization = "Bearer " + r.accessToken);
          var F = { baseURL: b, headers: r.headers, httpAgent: r.httpAgent, httpsAgent: r.httpsAgent, proxy: r.proxy, timeout: r.timeout, adapter: r.adapter, maxContentLength: r.maxContentLength, maxBodyLength: r.maxBodyLength, paramsSerializer: { serialize: function(K) {
            return or().stringify(K);
          } }, logHandler: r.logHandler, responseLogger: r.responseLogger, requestLogger: r.requestLogger, retryOnError: r.retryOnError }, B = t.create(F);
          return B.httpClientParams = e, B.cloneWithNewParams = function(K) {
            return We(t, Oe(Oe({}, we()(e)), K));
          }, r.onBeforeRequest && B.interceptors.request.use(r.onBeforeRequest), typeof r.accessToken == "function" && function(K, V) {
            K.interceptors.request.use(function(pt) {
              return V().then(function(Nt) {
                return pt.headers.set("Authorization", "Bearer ".concat(Nt)), pt;
              });
            });
          }(B, r.accessToken), r.throttle && fr(B, r.throttle), function(K) {
            var V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5, pt = K.defaults, Nt = pt.responseLogger, Gt = Nt === void 0 ? Le : Nt, Dt = pt.requestLogger, It = Dt === void 0 ? Le : Dt;
            K.interceptors.request.use(function(ut) {
              return It(ut), ut;
            }, function(ut) {
              return It(ut), Promise.reject(ut);
            }), K.interceptors.response.use(function(ut) {
              return Gt(ut), ut;
            }, function(ut) {
              var St = ut.response, xt = ut.config;
              if (Gt(ut), !xt || !K.defaults.retryOnError)
                return Promise.reject(ut);
              var Mt = xt.attempts || 1;
              if (Mt > V)
                return ut.attempts = xt.attempts, Promise.reject(ut);
              var te = null, me = lr(Mt);
              return St ? St.status >= 500 && St.status < 600 ? te = "Server ".concat(St.status) : St.status === 429 && (te = "Rate limit", St.headers && ut.response.headers["x-contentful-ratelimit-reset"] && (me = St.headers["x-contentful-ratelimit-reset"])) : te = "Connection", te ? (me = Math.floor(1e3 * me + 200 * Math.random() + 500), K.defaults.logHandler("warning", "".concat(te, " error occurred. Waiting for ").concat(me, " ms before retrying...")), xt.attempts = Mt + 1, delete xt.httpAgent, delete xt.httpsAgent, ur(me).then(function() {
                return K(xt);
              })) : Promise.reject(ut);
            });
          }(B, r.retryLimit), r.onError && B.interceptors.response.use(function(K) {
            return K;
          }, r.onError), B;
        }
        function Xt(t) {
          var e = t.query, r = {};
          return delete e.resolveLinks, r.params = we()(e), r;
        }
        function ze(t) {
          var e, r = function(o, a) {
            var i = typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
            if (!i) {
              if (Array.isArray(o) || (i = De(o))) {
                i && (o = i);
                var l = 0, u = function() {
                };
                return { s: u, n: function() {
                  return l >= o.length ? { done: !0 } : { done: !1, value: o[l++] };
                }, e: function(b) {
                  throw b;
                }, f: u };
              }
              throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            var s, f = !0, v = !1;
            return { s: function() {
              i = i.call(o);
            }, n: function() {
              var b = i.next();
              return f = b.done, b;
            }, e: function(b) {
              v = !0, s = b;
            }, f: function() {
              try {
                f || i.return == null || i.return();
              } finally {
                if (v)
                  throw s;
              }
            } };
          }(Object.getOwnPropertyNames(t));
          try {
            for (r.s(); !(e = r.n()).done; ) {
              var n = t[e.value];
              n && Se(n) === "object" && ze(n);
            }
          } catch (o) {
            r.e(o);
          } finally {
            r.f();
          }
          return Object.freeze(t);
        }
        function He() {
          var t = window;
          if (!t)
            return null;
          var e = t.navigator.userAgent, r = t.navigator.platform;
          return ["Macintosh", "MacIntel", "MacPPC", "Mac68K"].indexOf(r) !== -1 ? "macOS" : ["iPhone", "iPad", "iPod"].indexOf(r) !== -1 ? "iOS" : ["Win32", "Win64", "Windows", "WinCE"].indexOf(r) !== -1 ? "Windows" : /Android/.test(e) ? "Android" : /Linux/.test(r) ? "Linux" : null;
        }
        function $e(t) {
          return Object.defineProperty(t, "toPlainObject", { enumerable: !1, configurable: !1, writable: !1, value: function() {
            return we()(this);
          } });
        }
        function Zt(t) {
          var e, r = t.config, n = t.response;
          if (r && r.headers && r.headers.Authorization) {
            var o = "...".concat(r.headers.Authorization.toString().substr(-5));
            r.headers.Authorization = "Bearer ".concat(o);
          }
          if (!ke()(n) || !ke()(r))
            throw t;
          var a, i = n == null ? void 0 : n.data, l = { status: n == null ? void 0 : n.status, statusText: n == null ? void 0 : n.statusText, message: "", details: {} };
          r && ke()(r) && (l.request = { url: r.url, headers: r.headers, method: r.method, payloadData: r.data }), i && Se(i) === "object" && ("requestId" in i && (l.requestId = i.requestId || "UNKNOWN"), "message" in i && (l.message = i.message || ""), "details" in i && (l.details = i.details || {}), e = (a = i.sys) === null || a === void 0 ? void 0 : a.id);
          var u = new Error();
          u.name = e && e !== "Unknown" ? e : "".concat(n == null ? void 0 : n.status, " ").concat(n == null ? void 0 : n.statusText);
          try {
            u.message = JSON.stringify(l, null, "  ");
          } catch {
            var s;
            u.message = (s = l == null ? void 0 : l.message) !== null && s !== void 0 ? s : "";
          }
          throw u;
        }
        function Ge(t) {
          return function(e) {
            return Object.assign({}, t, e);
          };
        }
        var yr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
          return typeof t;
        } : function(t) {
          return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        };
        function ye(t) {
          if (Array.isArray(t)) {
            for (var e = 0, r = Array(t.length); e < t.length; e++)
              r[e] = t[e];
            return r;
          }
          return Array.from(t);
        }
        var de = {}, Je = function(t, e) {
          var r = e.entryId, n = e.linkType, o = e.spaceId, a = e.environmentId;
          return o && a ? t.get(o + "!" + a + "!" + n + "!" + r) : t.get(n + "!" + r);
        }, dr = function(t, e) {
          var r = e.sys, n = r.type, o = r.linkType;
          if (n === "ResourceLink") {
            var a = function(v) {
              var b = /.*:spaces\/([^/]+)(?:\/environments\/([^/]+))?\/entries\/([^/]+)$/;
              if (b.test(v)) {
                var F = function(V, pt) {
                  if (Array.isArray(V))
                    return V;
                  if (Symbol.iterator in Object(V))
                    return function(Nt, Gt) {
                      var Dt = [], It = !0, ut = !1, St = void 0;
                      try {
                        for (var xt, Mt = Nt[Symbol.iterator](); !(It = (xt = Mt.next()).done) && (Dt.push(xt.value), !Gt || Dt.length !== Gt); It = !0)
                          ;
                      } catch (te) {
                        ut = !0, St = te;
                      } finally {
                        try {
                          !It && Mt.return && Mt.return();
                        } finally {
                          if (ut)
                            throw St;
                        }
                      }
                      return Dt;
                    }(V, pt);
                  throw new TypeError("Invalid attempt to destructure non-iterable instance");
                }(v.match(b), 4), B = (F[0], F[1]), K = F[2];
                return { spaceId: B, environmentId: K === void 0 ? "master" : K, entryId: F[3] };
              }
            }(e.sys.urn), i = a.spaceId, l = a.environmentId, u = a.entryId, s = o.split(":")[1];
            return Je(t, { linkType: s, entryId: u, spaceId: i, environmentId: l }) || de;
          }
          var f = e.sys.id;
          return Je(t, { linkType: o, entryId: f }) || de;
        }, hr = function t(e, r, n, o) {
          if (r(e))
            return n(e);
          if (e && (e === void 0 ? "undefined" : yr(e)) === "object") {
            for (var a in e)
              e.hasOwnProperty(a) && (e[a] = t(e[a], r, n, o));
            o && (e = function(i) {
              if (Array.isArray(i))
                return i.filter(function(u) {
                  return u !== de;
                });
              for (var l in i)
                i[l] === de && delete i[l];
              return i;
            }(e));
          }
          return e;
        }, Ve = function(t, e) {
          if (e = e || {}, !t.items)
            return [];
          var r = we()(t), n = Object.keys(r.includes || {}).reduce(function(i, l) {
            return [].concat(ye(i), ye(t.includes[l]));
          }, []), o = [].concat(ye(r.items), ye(n)).filter(function(i) {
            return !!i.sys;
          }), a = new Map(o.reduce(function(i, l) {
            var u, s = (u = l.sys, u.space && u.environment ? [u.type + "!" + u.id, u.space.sys.id + "!" + u.environment.sys.id + "!" + u.type + "!" + u.id] : [u.type + "!" + u.id]).map(function(f) {
              return [f, l];
            });
            return i.push.apply(i, ye(s)), i;
          }, []));
          return o.forEach(function(i) {
            var l = function(u, s) {
              return Array.isArray(s) ? Object.keys(u).filter(function(f) {
                return s.indexOf(f) !== -1;
              }).reduce(function(f, v) {
                return f[v] = u[v], f;
              }, {}) : u;
            }(i, e.itemEntryPoints);
            Object.assign(i, hr(l, function(u) {
              return (s = u) && s.sys && s.sys.type === "Link" || function(f) {
                return f && f.sys && f.sys.type === "ResourceLink";
              }(u);
              var s;
            }, function(u) {
              return function(s, f, v) {
                var b = dr(s, f);
                return b === de ? v ? b : f : b;
              }(a, u, e.removeUnresolved);
            }, e.removeUnresolved));
          }), r.items;
        }, mr = lt(784), gr = lt.n(mr);
        function Ke(t) {
          return Object.defineProperty(t, "stringifySafe", { enumerable: !1, configurable: !1, writable: !1, value: function(e = null, r = "") {
            return gr()(this, e, r, (n, o) => ({ sys: { type: "Link", linkType: "Entry", id: o.sys.id, circular: !0 } }));
          } });
        }
        async function br(t, e, r) {
          if (!e || !e.initial && !e.nextSyncToken && !e.nextPageToken)
            throw new Error("Please provide one of `initial`, `nextSyncToken` or `nextPageToken` parameters for syncing");
          if (e.content_type && !e.type)
            e.type = "Entry";
          else if (e.content_type && e.type && e.type !== "Entry")
            throw new Error("When using the `content_type` filter your `type` parameter cannot be different from `Entry`.");
          const { withoutLinkResolution: n, withoutUnresolvableLinks: o, paginate: a } = { withoutLinkResolution: !1, withoutUnresolvableLinks: !1, paginate: !0, ...r }, i = await Qe(t, [], e, { paginate: a });
          n || (i.items = Ve(i, { removeUnresolved: o, itemEntryPoints: ["fields"] }));
          const l = function(s) {
            const f = (v) => (b, F) => (F.sys.type === v && b.push($e(F)), b);
            return { entries: s.reduce(f("Entry"), []), assets: s.reduce(f("Asset"), []), deletedEntries: s.reduce(f("DeletedEntry"), []), deletedAssets: s.reduce(f("DeletedAsset"), []) };
          }(i.items);
          return i.nextSyncToken && (l.nextSyncToken = i.nextSyncToken), i.nextPageToken && (l.nextPageToken = i.nextPageToken), ze((u = Ke($e(l))).sys || {}), u;
          var u;
        }
        async function Qe(t, e, r, { paginate: n }) {
          const o = (a = r).nextPageToken ? { sync_token: a.nextPageToken } : a.nextSyncToken ? { sync_token: a.nextSyncToken } : a.sync_token ? { sync_token: a.sync_token } : a;
          var a;
          const i = (await t.get("sync", Xt({ query: o }))).data || {};
          return e = e.concat(i.items || []), i.nextPageUrl ? n ? (delete o.initial, o.sync_token = _e(i.nextPageUrl), Qe(t, e, o, { paginate: n })) : { items: e, nextPageToken: _e(i.nextPageUrl) } : i.nextSyncUrl ? { items: e, nextSyncToken: _e(i.nextSyncUrl) } : { items: [] };
        }
        function _e(t) {
          const e = t.split("?");
          return e.length > 0 ? e[1].replace("sync_token=", "") : "";
        }
        function Ce(t) {
          const e = {};
          let r = !1;
          for (const n in t)
            Array.isArray(t[n]) && (e[n] = t[n].join(","), r = !0);
          return r ? { ...t, ...e } : t;
        }
        function he(t) {
          if (!t.select)
            return t;
          const e = Array.isArray(t.select) ? t.select : t.select.split(",").map((n) => n.trim()), r = new Set(e);
          return r.has("sys") ? t : (r.add("sys.id"), r.add("sys.type"), { ...t, select: [...r].join(",") });
        }
        function Xe(t, { resolveLinks: e, removeUnresolved: r }) {
          const n = Ke(t);
          return e && (n.items = Ve(n, { removeUnresolved: r, itemEntryPoints: ["fields"] })), n;
        }
        class Yt extends Error {
          constructor(e, r) {
            super(`Invalid "${e}" provided, ` + r), this.name = "ValidationError";
          }
        }
        function Ee(t, e) {
          e ? function(r) {
            if (r.locale)
              throw new Yt("locale", "The `locale` parameter is not allowed");
          }(t) : function(r) {
            if (r.locale === "*")
              throw new Yt("locale", `The use of locale='*' is no longer supported.To fetch an entry in all existing locales, 
      use client.withAllLocales instead of the locale='*' parameter.`);
          }(t);
        }
        function je(t) {
          if ("resolveLinks" in t)
            throw new Yt("resolveLinks", `The use of the 'resolveLinks' parameter is no longer supported. By default, links are resolved. 
      If you do not want to resolve links, use client.withoutLinkResolution.`);
        }
        function xe(t) {
          if ("removeUnresolved" in t)
            throw new Yt("removeUnresolved", `The use of the 'removeUnresolved' parameter is no longer supported. By default, unresolved links are kept as link objects.
      If you do not want to include unresolved links, use client.withoutUnresolvableLinks.`);
        }
        function ce(t) {
          for (const e in t) {
            const r = t[e];
            if (typeof r == "object" && r !== null && !Array.isArray(r))
              throw new Error(`Objects are not supported as value for the "${e}" query parameter.`);
          }
        }
        class vr extends Error {
          constructor(r, n, o) {
            super("The resource could not be found.");
            Fe(this, "sys");
            Fe(this, "details");
            this.sys = { type: "Error", id: "NotFound" }, this.details = { type: "Entry", id: r, environment: n, space: o };
          }
        }
        function Ze({ http: t, getGlobalOptions: e }, r) {
          const n = (l = "unknown") => new vr(l, e().environment, e().space), o = (l) => {
            let u = l === "space" ? e().spaceBaseUrl : e().environmentBaseUrl;
            if (!u)
              throw new Error("Please define baseUrl for " + l);
            return u.endsWith("/") || (u += "/"), u;
          };
          async function a({ context: l, path: u, config: s }) {
            const f = o(l);
            try {
              return (await t.get(f + u, s)).data;
            } catch (v) {
              Zt(v);
            }
          }
          async function i(l, u) {
            const { withoutLinkResolution: s, withoutUnresolvableLinks: f } = u;
            try {
              return Xe(await a({ context: "environment", path: "entries", config: Xt({ query: Ce(he(l)) }) }), { resolveLinks: !s, removeUnresolved: f ?? !1 });
            } catch (v) {
              Zt(v);
            }
          }
          return { version: "10.6.14", getSpace: async function() {
            return a({ context: "space", path: "" });
          }, getContentType: async function(l) {
            return a({ context: "environment", path: `content_types/${l}` });
          }, getContentTypes: async function(l = {}) {
            return a({ context: "environment", path: "content_types", config: Xt({ query: l }) });
          }, getAsset: async function(l, u = {}) {
            return async function(s, f, v = { withAllLocales: !1, withoutLinkResolution: !1, withoutUnresolvableLinks: !1 }) {
              const { withAllLocales: b } = v;
              return Ee(f, b), ce(f), async function(F, B) {
                try {
                  return a({ context: "environment", path: `assets/${F}`, config: Xt({ query: he(B) }) });
                } catch (K) {
                  Zt(K);
                }
              }(s, b ? { ...f, locale: "*" } : f);
            }(l, u, r);
          }, getAssets: async function(l = {}) {
            return async function(u, s = { withAllLocales: !1, withoutLinkResolution: !1, withoutUnresolvableLinks: !1 }) {
              const { withAllLocales: f } = s;
              return Ee(u, f), ce(u), async function(v) {
                try {
                  return a({ context: "environment", path: "assets", config: Xt({ query: Ce(he(v)) }) });
                } catch (b) {
                  Zt(b);
                }
              }(f ? { ...u, locale: "*" } : u);
            }(l, r);
          }, getTag: async function(l) {
            return a({ context: "environment", path: `tags/${l}` });
          }, getTags: async function(l = {}) {
            return ce(l), a({ context: "environment", path: "tags", config: Xt({ query: Ce(he(l)) }) });
          }, getLocales: async function(l = {}) {
            return ce(l), a({ context: "environment", path: "locales", config: Xt({ query: he(l) }) });
          }, parseEntries: function(l) {
            return function(u, s = { withAllLocales: !1, withoutLinkResolution: !1, withoutUnresolvableLinks: !1 }) {
              return function(f, v) {
                const { withoutLinkResolution: b, withoutUnresolvableLinks: F } = v;
                return Xe(f, { resolveLinks: !b, removeUnresolved: F ?? !1 });
              }(u, s);
            }(l, r);
          }, sync: async function(l, u = { paginate: !0 }) {
            return async function(s, f, v = { withAllLocales: !1, withoutLinkResolution: !1, withoutUnresolvableLinks: !1 }) {
              je(s), xe(s);
              const b = { ...f, ...v };
              return function(F) {
                F.defaults.baseURL = e().environmentBaseUrl;
              }(t), br(t, s, b);
            }(l, u, r);
          }, getEntry: async function(l, u = {}) {
            return async function(s, f, v = { withAllLocales: !1, withoutLinkResolution: !1, withoutUnresolvableLinks: !1 }) {
              const { withAllLocales: b } = v;
              return Ee(f, b), je(f), xe(f), ce(f), async function(F, B, K) {
                if (!F)
                  throw n(F);
                try {
                  const V = await i({ "sys.id": F, ...B }, K);
                  if (V.items.length > 0)
                    return V.items[0];
                  throw n(F);
                } catch (V) {
                  Zt(V);
                }
              }(s, b ? { ...f, locale: "*" } : f, v);
            }(l, u, r);
          }, getEntries: async function(l = {}) {
            return async function(u, s = { withAllLocales: !1, withoutLinkResolution: !1, withoutUnresolvableLinks: !1 }) {
              const { withAllLocales: f } = s;
              return Ee(u, f), je(u), xe(u), ce(u), i(f ? { ...u, locale: "*" } : u, s);
            }(l, r);
          }, createAssetKey: async function(l) {
            try {
              const u = Math.floor(Date.now() / 1e3);
              (function(s, f, v) {
                if (v = v || {}, typeof f != "number")
                  throw new Yt(s, `only numeric values are allowed for timestamps, provided type was "${typeof f}"`);
                if (v.maximum && f > v.maximum)
                  throw new Yt(s, `value (${f}) cannot be further in the future than expected maximum (${v.maximum})`);
                if (v.now && f < v.now)
                  throw new Yt(s, `value (${f}) cannot be in the past, current time was ${v.now}`);
              })("expiresAt", l, { maximum: u + 172800, now: u });
            } catch (u) {
              Zt(u);
            }
            return async function({ context: u, path: s, data: f, config: v }) {
              const b = o(u);
              try {
                return (await t.post(b + s, f, v)).data;
              } catch (F) {
                Zt(F);
              }
            }({ context: "environment", path: "asset_keys", data: { expiresAt: l } });
          } };
        }
        const wr = ({ http: t, getGlobalOptions: e }) => {
          function r(n) {
            return function({ http: o, getGlobalOptions: a }, i, l) {
              const u = Ze({ http: o, getGlobalOptions: a }, i);
              return Object.defineProperty(u, "withAllLocales", { get: () => l({ ...i, withAllLocales: !0 }) }), Object.defineProperty(u, "withoutLinkResolution", { get: () => l({ ...i, withoutLinkResolution: !0 }) }), Object.defineProperty(u, "withoutUnresolvableLinks", { get: () => l({ ...i, withoutUnresolvableLinks: !0 }) }), Object.create(u);
            }({ http: t, getGlobalOptions: e }, n, r);
          }
          return { ...Ze({ http: t, getGlobalOptions: e }, { withoutLinkResolution: !1, withAllLocales: !1, withoutUnresolvableLinks: !1 }), get withAllLocales() {
            return r({ withAllLocales: !0, withoutLinkResolution: !1, withoutUnresolvableLinks: !1 });
          }, get withoutLinkResolution() {
            return r({ withAllLocales: !1, withoutLinkResolution: !0, withoutUnresolvableLinks: !1 });
          }, get withoutUnresolvableLinks() {
            return r({ withAllLocales: !1, withoutLinkResolution: !1, withoutUnresolvableLinks: !0 });
          } };
        };
        function Or(t) {
          if (!t.accessToken)
            throw new TypeError("Expected parameter accessToken");
          if (!t.space)
            throw new TypeError("Expected parameter space");
          je(t), xe(t);
          const e = { resolveLinks: !0, removeUnresolved: !1, defaultHostname: "cdn.contentful.com", environment: "master", ...t }, r = function(a, i, l, u) {
            var s = [];
            i && s.push("app ".concat(i)), l && s.push("integration ".concat(l)), u && s.push("feature " + u), s.push("sdk ".concat(a));
            var f = null;
            try {
              typeof window < "u" && "navigator" in window && "product" in window.navigator && window.navigator.product === "ReactNative" ? (f = He(), s.push("platform ReactNative")) : typeof process > "u" || process.browser ? (f = He(), s.push("platform browser")) : (f = function() {
                var v = process.platform || "linux", b = process.version || "0.0.0", F = { android: "Android", aix: "Linux", darwin: "macOS", freebsd: "Linux", linux: "Linux", openbsd: "Linux", sunos: "Linux", win32: "Windows" };
                return v in F ? "".concat(F[v] || "Linux", "/").concat(b) : null;
              }(), s.push("platform node.js/".concat(process.versions && process.versions.node ? "v".concat(process.versions.node) : process.version)));
            } catch {
              f = null;
            }
            return f && s.push("os ".concat(f)), "".concat(s.filter(function(v) {
              return v !== "";
            }).join("; "), ";");
          }("contentful.js/10.6.14", e.application, e.integration);
          e.headers = { ...e.headers, "Content-Type": "application/vnd.contentful.delivery.v1+json", "X-Contentful-User-Agent": r };
          const n = We(er, e);
          if (!n.defaults.baseURL)
            throw new Error("Please define a baseURL");
          const o = Ge({ space: e.space, environment: e.environment, spaceBaseUrl: n.defaults.baseURL, environmentBaseUrl: `${n.defaults.baseURL}environments/${e.environment}` });
          return n.defaults.baseURL = o({}).environmentBaseUrl, wr({ http: n, getGlobalOptions: o });
        }
      }(), Pe;
    }();
  });
})(Ye);
var Pr = Ye.exports;
export {
  Pr as c
};
